import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import { palette } from "../../../assets/styles/Palette";
import AtomPersonaLoader from "../../Global/components/atoms/AtomPersonaLoader";
import { Button } from "../../../assets/styles/ButtonStyle";
import images from "../../../assets/styles/Images";
import PopupWrap from "../../../assets/styles/Popup";
import Markdown from "markdown-to-jsx";
import {
  ContentsWrap,
  MainContent,
  TabWrapType4,
  TabButtonType4,
  TabWrapType5,
  TabButtonType5,
  TabContent5,
  TabContent5Item,
  BgBoxItem,
  DropzoneStyles,
  Title,
  ListBoxGroup,
  BoxWrap,
  InterviewPopup,
} from "../../../assets/styles/BusinessAnalysisStyle";
import {
  H4,
  H3,
  Sub3,
  Body1,
  Body2,
  Body3,
  Caption1,
  InputText,
} from "../../../assets/styles/Typography";
import {
  FormBox,
  CustomTextarea,
  CustomInput,
  SelectBox,
  SelectBoxItem,
  SelectBoxTitle,
  SelectBoxList,
  RadioButton,
} from "../../../assets/styles/InputStyle";
import "react-dropzone-uploader/dist/styles.css";
import { useDynamicViewport } from "../../../assets/DynamicViewport";
import MoleculeFileUpload from "../components/molecules/MoleculeFileUpload";
import OrganismDesignConceptSelector from "../components/organisms/OrganismDesignConceptSelector";
import MoleculeAnalysisCard from "../components/molecules/MoleculeAnalysisCard";
import MoleculeTemplateCard from "../components/molecules/MoleculeTemplateCard";
import MoleculeCreateDisplayHeader from "../components/molecules/MoleculeCreateDisplayHeader";
import OrganismDisplayViewEduPreview from "../../Global/components/organisms/OrganismDisplayViewEduPreview";
import MoleculeMessageCard from "../../CreatApiContentPage/components/molecules/MoleculeMessageCard";

import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DESIGN_GENERATOR,
  AUTODISPLAY_SELECTED_CONTENT,
  CUSTOMER_ID,
} from "../../AtomStates";
import { useAtom } from "jotai";
import {
  createEduViewOnServer,
  updateEduViewOnServer,
  AutoDisplayFileAnalysisMultimodalRequest,
  AutoDisplayFileAnalysisRequest,
  AutoDisplayContentGeneratorRequest,
  AutoDisplayDesignGeneratorRequest,
  getUserMemberType,
} from "../../../utils/indexedDB";
import file1 from "../../../assets/files/2025 여름철 물놀이 안전 수칙 및 화재 대피 요령 안내 가정통신문.pdf";
import file2 from "../../../assets/files/2025학년도 졸업앨범 주요 내용 안내 가정통신문.pdf";
import file3 from "../../../assets/files/[붙임1] 기후과학클래스 모집 포스터.jpg";
import file4_1 from "../../../assets/files/2025 융합과학교육원 본원 메이커 발명 캠프 신청 안내.pdf";
import file4_2 from "../../../assets/files/2025 융합과학교육원 본원 메이커 발명 캠프 포스터.png";
import file5 from "../../../assets/files/2025학년도 한성과학고등학교 발명교육센터 발명심화・특별과정 운영 계획.pdf";

const GlobalStyle = createGlobalStyle`  
  .markdown-body p {
    margin-bottom: 12px !important;
  }
`;

const designConceptsData = [
  {
    id: "concept1",
    name: "컨셉1",
    description: "컨셉1",
  },
  {
    id: "concept2",
    name: "컨셉2",
    description: "컨셉2",
  },
  {
    id: "concept3",
    name: "컨셉3",
    description: "컨셉3",
  },
  {
    id: "concept4",
    name: "컨셉4",
    description: "컨셉4",
  },
  {
    id: "concept5",
    name: "컨셉5",
    description: "컨셉5",
  },
  {
    id: "concept6",
    name: "컨셉6",
    description: "컨셉6",
  },
  {
    id: "concept7",
    name: "컨셉7",
    description: "컨셉7",
  },
  {
    id: "concept8",
    name: "컨셉8",
    description: "컨셉8",
  },
  {
    id: "concept9",
    name: "컨셉9",
    description: "컨셉9",
  },
];

// 컴포넌트 상단에 옵션 배열 정의
const contentTypeOptions = [
  "정보전달형 (행사 일정 및 공지 사항을 안내할 때 사용) ",
  "프로그램 안내형 (교육, 캠프, 활동 참여 등의 기회를 소개할 때 사용) ",
  "행사/대회 홍보형 (교내/외 대회 및 공모전을 소개하고, 학샘 참여를 유도할 때 사용) ",
  "의견수렴형 (학생 또는 학부모의 참여를 유도할 때 사용) ",
  "창의활동/문화활동 소개형 (특별활동, 동아리 등 비교과 교육 기회를 소개할 때 사용) ",
];

const targetAudienceOptions = [
  {
    id: "allGrades",
    name: "전교생",
    icon: (
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.3965 17.478C14.3965 17.4205 14.3943 17.36 14.3909 17.2966C13.5599 17.1737 12.9162 16.9953 12.4294 16.7972C12.1672 16.6906 11.9453 16.5746 11.7606 16.4569C10.5039 17.0595 9.00496 17.293 7.65453 17.3533C6.49298 17.4052 5.38047 17.3312 4.51683 17.2199C4.50432 17.3205 4.49538 17.4151 4.49127 17.5028V18.9729L4.00707 19.1343C3.99661 19.1469 3.97956 19.1663 3.96153 19.1982C3.9017 19.3043 3.81211 19.5376 3.81211 19.9677C3.81212 20.2619 3.92857 20.4834 4.09656 20.6604C4.23251 20.8036 4.39094 20.9027 4.50884 20.9593L4.61112 21.0016L4.93232 21.1095L5.08413 21.4123C5.47022 22.1844 6.47088 23.5293 7.86946 24.1896C8.38562 24.4333 8.94906 24.5811 9.55696 24.5811C10.1642 24.5811 10.7136 24.4336 11.2069 24.1936C12.5453 23.5424 13.4519 22.2137 13.7861 21.4498L13.9052 21.179L14.1696 21.0463C14.3184 20.972 14.5733 20.8038 14.7793 20.5773C14.9877 20.348 15.0757 20.1398 15.0757 19.9677C15.0757 19.3372 14.7607 19.064 14.7609 19.064L14.3965 18.8211V17.478ZM2.4546 32.7278H16.6593V32.3603C16.6593 30.6691 16.3712 29.104 15.4384 27.9681C14.4641 26.7818 13.185 25.8213 11.7271 25.7541C11.0828 26.0382 10.3568 26.2175 9.55696 26.2175C8.78271 26.2175 8.07037 26.0506 7.43081 25.7844C6.16935 26.0813 4.09039 26.9776 3.00352 28.6329C2.54205 29.3358 2.45461 30.2597 2.4546 31.3671V32.7278ZM16.0329 18.0293C16.3863 18.4334 16.7121 19.0913 16.7121 19.9677C16.712 20.7007 16.347 21.2845 15.9898 21.6776C15.7252 21.9686 15.4252 22.1985 15.1644 22.3607C14.8544 22.9812 14.3197 23.7879 13.5672 24.5044C14.8746 25.0267 15.9337 25.9931 16.7033 26.9302C17.998 28.5069 18.2957 30.5414 18.2957 32.3603V33.0937C18.2955 33.7954 17.727 34.3641 17.0253 34.3642H2.08866C1.43081 34.364 0.889632 33.8639 0.824629 33.2232L0.818237 33.0937V31.3671C0.818243 30.2595 0.881464 28.8835 1.63562 27.7348C2.6502 26.1896 4.25071 25.2129 5.62346 24.6562C4.76436 23.9229 4.1368 23.0692 3.76737 22.4174C3.48994 22.2799 3.18133 22.0728 2.91003 21.787C2.51231 21.3681 2.17576 20.7597 2.17575 19.9677C2.17575 19.0644 2.45054 18.3748 2.8549 17.9662V17.4604L2.8557 17.4428C2.87344 17.0348 2.94616 16.5631 3.08661 16.0685C3.17243 15.7664 3.28451 15.4524 3.42699 15.1369C3.56818 14.8242 3.73996 14.5088 3.94634 14.2005C4.20619 13.8123 4.52132 13.4352 4.90036 13.0906C5.37968 12.655 5.95643 12.2755 6.64219 11.992C7.46736 11.6509 8.43427 11.4551 9.55696 11.4551C10.8279 11.4551 11.892 11.7054 12.7698 12.1358C13.3113 12.4014 13.7731 12.7319 14.164 13.1018C14.5315 13.4496 14.8332 13.8299 15.0781 14.2212C15.2725 14.5319 15.4316 14.8497 15.5599 15.1641C15.7343 15.5915 15.8533 16.0161 15.9282 16.4129C16.0001 16.7937 16.0329 17.1554 16.0329 17.478V18.0293Z" fill="#DEDEDE"/>
<path d="M30.7601 17.478C30.7601 17.4205 30.7578 17.36 30.7545 17.2966C29.9234 17.1737 29.2798 16.9953 28.7929 16.7972C28.5307 16.6906 28.3088 16.5746 28.1241 16.4569C26.8674 17.0595 25.3685 17.293 24.0181 17.3533C22.8565 17.4052 21.744 17.3312 20.8804 17.2199C20.8678 17.3205 20.8589 17.4151 20.8548 17.5028V18.9729L20.3706 19.1343C20.3601 19.1469 20.3431 19.1663 20.3251 19.1982C20.2652 19.3043 20.1756 19.5376 20.1756 19.9677C20.1756 20.2619 20.2921 20.4834 20.4601 20.6604C20.596 20.8036 20.7545 20.9027 20.8724 20.9593L20.9746 21.0016L21.2958 21.1095L21.4477 21.4123C21.8337 22.1844 22.8344 23.5293 24.233 24.1896C24.7491 24.4333 25.3126 24.5811 25.9205 24.5811C26.5277 24.5811 27.0772 24.4336 27.5704 24.1936C28.9088 23.5424 29.8155 22.2137 30.1496 21.4498L30.2687 21.179L30.5331 21.0463C30.6819 20.972 30.9369 20.8038 31.1428 20.5773C31.3513 20.348 31.4392 20.1398 31.4392 19.9677C31.4392 19.3372 31.1242 19.064 31.1244 19.064L30.7601 18.8211V17.478ZM18.8181 32.7278H33.0228V32.3603C33.0228 30.6691 32.7348 29.104 31.802 27.9681C30.8276 26.7818 29.5485 25.8213 28.0906 25.7541C27.4463 26.0382 26.7203 26.2175 25.9205 26.2175C25.1462 26.2175 24.4339 26.0506 23.7943 25.7844C22.5329 26.0813 20.4539 26.9776 19.367 28.6329C18.9056 29.3358 18.8181 30.2597 18.8181 31.3671V32.7278ZM32.3964 18.0293C32.7499 18.4334 33.0756 19.0913 33.0756 19.9677C33.0756 20.7007 32.7105 21.2845 32.3533 21.6776C32.0887 21.9686 31.7887 22.1985 31.5279 22.3607C31.218 22.9812 30.6832 23.7879 29.9307 24.5044C31.2381 25.0267 32.2972 25.9931 33.0668 26.9302C34.3615 28.5069 34.6592 30.5414 34.6592 32.3603V33.0937C34.659 33.7954 34.0905 34.3641 33.3888 34.3642H18.4522C17.7943 34.364 17.2532 33.8639 17.1882 33.2232L17.1818 33.0937V31.3671C17.1818 30.2595 17.245 28.8835 17.9991 27.7348C19.0137 26.1896 20.6142 25.2129 21.987 24.6562C21.1279 23.9229 20.5003 23.0692 20.1309 22.4174C19.8535 22.2799 19.5449 22.0728 19.2736 21.787C18.8758 21.3681 18.5393 20.7597 18.5393 19.9677C18.5393 19.0644 18.8141 18.3748 19.2184 17.9662V17.4604L19.2192 17.4428C19.237 17.0348 19.3097 16.5631 19.4501 16.0685C19.536 15.7664 19.648 15.4524 19.7905 15.1369C19.9317 14.8242 20.1035 14.5088 20.3099 14.2005C20.5697 13.8123 20.8848 13.4352 21.2639 13.0906C21.7432 12.655 22.32 12.2755 23.0057 11.992C23.8309 11.6509 24.7978 11.4551 25.9205 11.4551C27.1915 11.4551 28.2555 11.7054 29.1333 12.1358C29.6748 12.4014 30.1367 12.7319 30.5276 13.1018C30.8951 13.4496 31.1967 13.8299 31.4416 14.2212C31.6361 14.5319 31.7951 14.8497 31.9234 15.1641C32.0978 15.5915 32.2168 16.0161 32.2918 16.4129C32.3637 16.7937 32.3964 17.1554 32.3964 17.478V18.0293Z" fill="#DEDEDE"/>
<path d="M22.4801 7.65962C22.4801 7.60217 22.477 7.54163 22.4737 7.47825C21.6428 7.35533 20.9989 7.1769 20.5121 6.97887C20.2499 6.87216 20.028 6.75622 19.8434 6.63849C18.5867 7.24103 17.0883 7.47461 15.7381 7.53498C14.5762 7.58692 13.4633 7.51286 12.5996 7.40154C12.5871 7.50207 12.5789 7.59672 12.5748 7.68439V9.15456L12.0898 9.31596C12.0794 9.32856 12.0629 9.34819 12.0451 9.37988C11.9852 9.48597 11.8956 9.71927 11.8956 10.1493C11.8956 10.4436 12.0121 10.6651 12.1801 10.8421C12.3612 11.0328 12.5814 11.1457 12.6938 11.1832L13.0158 11.2911L13.1669 11.5939C13.5529 12.366 14.5542 13.7109 15.953 14.3713C16.4692 14.6149 17.0326 14.7628 17.6405 14.7628C18.2476 14.7628 18.7964 14.6152 19.2896 14.3753C20.6282 13.7241 21.5354 12.3953 21.8696 11.6315L21.9879 11.3606L22.2532 11.228C22.4018 11.1536 22.6561 10.9854 22.862 10.759C23.0705 10.5297 23.1584 10.3214 23.1584 10.1493C23.1584 9.51817 22.8435 9.24506 22.8444 9.24565L22.4801 9.00275V7.65962ZM24.1164 8.21174C24.4697 8.61591 24.7948 9.27338 24.7948 10.1493C24.7948 10.8823 24.4305 11.4662 24.0733 11.8592C23.8085 12.1505 23.5081 12.381 23.2471 12.5431C22.7452 13.5476 21.6572 15.0436 20.0055 15.847C19.3142 16.1833 18.5219 16.3991 17.6405 16.3991C16.7599 16.3991 15.9591 16.1835 15.2547 15.851C13.5818 15.0613 12.4143 13.5945 11.8501 12.5991C11.5728 12.4615 11.2647 12.2542 10.9936 11.9687C10.5958 11.5497 10.2593 10.9413 10.2593 10.1493C10.2593 9.24564 10.5338 8.55553 10.9384 8.14702V7.64205L10.9392 7.62447C10.957 7.21651 11.0289 6.74471 11.1693 6.25018C11.2551 5.9481 11.3673 5.634 11.5097 5.31854C11.6509 5.00594 11.8228 4.69036 12.0291 4.3821C12.2889 3.99401 12.6042 3.61676 12.9831 3.27228C13.4623 2.83667 14.0393 2.45711 14.7249 2.17365C15.5501 1.83253 16.5177 1.63672 17.6405 1.63672C18.9113 1.63674 19.9748 1.88713 20.8525 2.31747C21.3941 2.58303 21.8566 2.91349 22.2476 3.28347C22.615 3.63125 22.9167 4.01161 23.1616 4.40288C23.3561 4.71357 23.5151 5.03128 23.6434 5.3457C23.8178 5.7731 23.9368 6.19772 24.0118 6.59455C24.0837 6.97532 24.1164 7.33706 24.1164 7.65962V8.21174Z" fill="#DEDEDE"/>
</svg>
    ),
  },
  {
    id: "gradeX",
    name: "1학년 학생",
    icon: (
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.5801 33.2305C30.58 34.0572 29.9098 34.7275 29.083 34.7275H6.67871C5.85206 34.7274 5.18177 34.0571 5.18164 33.2305V30.6406C5.18166 28.9793 5.2828 27.0285 6.34082 25.417C8.51419 22.1069 12.5844 20.5776 14.6729 20.1807C15.1168 20.0963 15.5455 20.3881 15.6299 20.832C15.714 21.2758 15.4223 21.7038 14.9785 21.7881C13.0964 22.1457 9.53432 23.5337 7.70801 26.3154C6.94287 27.4811 6.81838 28.9798 6.81836 30.6406V33.0908H28.9443V32.1299C28.9443 29.5614 28.5091 27.0971 27.0195 25.2832C25.4738 23.401 23.3623 21.8029 20.8926 21.8027C20.4407 21.8027 20.0742 21.4362 20.0742 20.9844C20.0742 20.5325 20.4407 20.166 20.8926 20.166C24.0885 20.1662 26.6177 22.2159 28.2842 24.2451C30.1356 26.4999 30.58 29.4337 30.5801 32.1299V33.2305Z" fill="#DEDEDE"/>
<path d="M10.1286 5.57315C9.85933 5.97538 9.63433 6.38882 9.44846 6.80043C9.26086 7.21586 9.11312 7.62943 9 8.0277C11.5256 8.50745 17.4586 8.93364 20.9852 6.80043C21.246 7.20952 22.5894 8.10952 25.8764 8.43679C25.7782 7.91663 25.622 7.36022 25.3935 6.80043C25.2255 6.38882 25.0185 5.97538 24.7668 5.57315C24.4499 5.06696 24.0622 4.57854 23.5924 4.13391C23.0933 3.66157 22.5015 3.23865 21.8034 2.89634C20.6744 2.34276 19.2675 2 17.5253 2C15.9857 2 14.6964 2.26767 13.6216 2.71197C12.7281 3.08132 11.9829 3.57274 11.3655 4.13391C10.8763 4.57854 10.4674 5.06696 10.1286 5.57315Z" fill="#DEDEDE"/>
<path d="M9.83691 11.7549L9.27734 11.9414C9.40139 11.9001 8.81836 12.1052 8.81836 13.542C8.81847 14.1076 9.04802 14.5364 9.35742 14.8623C9.59924 15.117 9.87875 15.2954 10.0986 15.4004L10.2959 15.4814L10.6172 15.5879L10.7686 15.8916C11.3737 17.1018 12.9318 19.2023 15.1387 20.2441C15.96 20.6319 16.8646 20.8701 17.8447 20.8701C18.8238 20.87 19.7079 20.6329 20.4971 20.249C22.6197 19.2164 24.0365 17.1317 24.5625 15.9297L24.6816 15.6582L24.9463 15.5254C25.2082 15.3944 25.6321 15.1126 25.9795 14.7305C26.3293 14.3457 26.5311 13.9403 26.5312 13.542C26.5312 12.4582 25.9892 11.9205 25.877 11.8457L25.5127 11.6035V9.80762C25.5127 9.45716 25.4771 9.04136 25.3916 8.58887C25.3028 8.11876 25.1614 7.61498 24.9551 7.10938C24.8035 6.73792 24.6176 6.36638 24.3926 6.00684C24.1095 5.55456 23.7641 5.12171 23.3486 4.72852C22.9077 4.31126 22.3836 3.93581 21.7617 3.63086C20.7581 3.13879 19.477 2.81842 17.8447 2.81836C16.4015 2.81836 15.219 3.06841 14.2529 3.46777C13.4495 3.79989 12.784 4.23967 12.2344 4.73926C11.7982 5.13573 11.4318 5.57292 11.127 6.02832C10.8847 6.39022 10.6812 6.76354 10.5127 7.13672C10.3426 7.51346 10.2092 7.88944 10.1064 8.25098C9.93893 8.84076 9.85738 9.38586 9.83691 9.8291V11.7549ZM27.1494 10.7959C27.6472 11.3105 28.167 12.2401 28.167 13.542C28.1669 14.5012 27.6891 15.2835 27.1904 15.832C26.7875 16.2751 26.324 16.6177 25.9414 16.8438C25.2423 18.2925 23.6458 20.5362 21.2129 21.7197C20.2254 22.2 19.0981 22.5068 17.8447 22.5068C16.5918 22.5068 15.4492 22.2013 14.4395 21.7246C11.9634 20.5556 10.2415 18.3431 9.45117 16.9023C9.04937 16.7187 8.57913 16.4191 8.1709 15.9893C7.63179 15.4214 7.18176 14.6054 7.18164 13.542C7.18164 12.1553 7.6311 11.2081 8.2002 10.7168V9.79004L8.20117 9.77246C8.22634 9.19363 8.32976 8.51654 8.53223 7.80371C8.65571 7.36904 8.8166 6.91762 9.02148 6.46387C9.22462 6.01403 9.47147 5.56053 9.76758 5.11816C10.1404 4.56128 10.5917 4.02105 11.1338 3.52832C11.8189 2.9056 12.6444 2.36264 13.6279 1.95605C14.8114 1.46683 16.2087 1.18164 17.8447 1.18164C19.6962 1.1817 21.2284 1.54721 22.4824 2.16211C23.2567 2.54177 23.9163 3.01263 24.4736 3.54004C24.9976 4.03597 25.4288 4.57874 25.7793 5.13867C26.0577 5.58349 26.2854 6.03954 26.4697 6.49121C26.7203 7.1052 26.8913 7.71494 26.999 8.28516C27.1025 8.83282 27.1494 9.35028 27.1494 9.80762V10.7959Z" fill="#DEDEDE"/>
<path d="M17.2303 26.4269C16.9821 26.519 16.7623 26.5439 16.5708 26.5013C16.3794 26.4517 16.234 26.3418 16.1347 26.1716C16.0638 26.051 16.0213 25.9305 16.0071 25.81C15.9929 25.6894 16 25.5795 16.0284 25.4802C16.0567 25.3739 16.1028 25.2781 16.1666 25.193C16.2305 25.108 16.2978 25.0406 16.3687 24.991L17.4643 24.2251C17.4855 24.211 17.5494 24.172 17.6557 24.1081C17.7621 24.0372 17.8826 24.0018 18.0174 24.0018C18.1025 23.9947 18.1982 24.0089 18.3045 24.0443C18.418 24.0798 18.5244 24.1365 18.6236 24.2145C18.7229 24.2854 18.8045 24.374 18.8683 24.4804C18.9392 24.5868 18.9746 24.7073 18.9746 24.842C18.9817 25.2675 18.9853 25.771 18.9853 26.3524C18.9924 26.9339 18.9959 27.533 18.9959 28.15C18.9959 28.7669 18.9924 29.366 18.9853 29.9475C18.9853 30.5219 18.9853 31.0182 18.9853 31.4366C18.9853 31.543 18.9534 31.6351 18.8895 31.7131C18.8328 31.7982 18.7584 31.8656 18.6662 31.9152C18.574 31.972 18.4712 32.011 18.3577 32.0322C18.2514 32.0606 18.1521 32.0712 18.0599 32.0641C17.9606 32.0641 17.8578 32.0464 17.7515 32.011C17.6522 31.9826 17.56 31.94 17.4749 31.8833C17.3969 31.8266 17.3331 31.7592 17.2835 31.6812C17.2338 31.6032 17.209 31.5146 17.209 31.4153C17.209 31.2097 17.209 30.9686 17.209 30.692C17.2161 30.4084 17.2196 30.1141 17.2196 29.8092C17.2196 29.4972 17.2196 29.1781 17.2196 28.852C17.2267 28.5258 17.2303 28.2138 17.2303 27.916C17.2303 27.611 17.2303 27.331 17.2303 27.0757C17.2303 26.8204 17.2303 26.6041 17.2303 26.4269Z" fill="#DEDEDE"/>
</svg>
    ),
  },
  {
    id: "grade2",
    name: "2학년 학생",
    icon: (
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.5801 33.2305C30.58 34.0572 29.9098 34.7275 29.083 34.7275H6.67871C5.85206 34.7274 5.18177 34.0571 5.18164 33.2305V30.6406C5.18166 28.9793 5.2828 27.0285 6.34082 25.417C8.51419 22.1069 12.5844 20.5776 14.6729 20.1807C15.1168 20.0963 15.5455 20.3881 15.6299 20.832C15.714 21.2758 15.4223 21.7038 14.9785 21.7881C13.0964 22.1457 9.53432 23.5337 7.70801 26.3154C6.94287 27.4811 6.81838 28.9798 6.81836 30.6406V33.0908H28.9443V32.1299C28.9443 29.5614 28.5091 27.0971 27.0195 25.2832C25.4738 23.401 23.3623 21.8029 20.8926 21.8027C20.4407 21.8027 20.0742 21.4362 20.0742 20.9844C20.0742 20.5325 20.4407 20.166 20.8926 20.166C24.0885 20.1662 26.6177 22.2159 28.2842 24.2451C30.1356 26.4999 30.58 29.4337 30.5801 32.1299V33.2305Z" fill="#DEDEDE"/>
<path d="M10.1286 5.57315C9.85933 5.97538 9.63433 6.38882 9.44846 6.80043C9.26086 7.21586 9.11312 7.62943 9 8.0277C11.5256 8.50745 17.4586 8.93364 20.9852 6.80043C21.246 7.20952 22.5894 8.10952 25.8764 8.43679C25.7782 7.91663 25.622 7.36022 25.3935 6.80043C25.2255 6.38882 25.0185 5.97538 24.7668 5.57315C24.4499 5.06696 24.0622 4.57854 23.5924 4.13391C23.0933 3.66157 22.5015 3.23865 21.8034 2.89634C20.6744 2.34276 19.2675 2 17.5253 2C15.9857 2 14.6964 2.26767 13.6216 2.71197C12.7281 3.08132 11.9829 3.57274 11.3655 4.13391C10.8763 4.57854 10.4674 5.06696 10.1286 5.57315Z" fill="#DEDEDE"/>
<path d="M9.83691 11.7549L9.27734 11.9414C9.40139 11.9001 8.81836 12.1052 8.81836 13.542C8.81847 14.1076 9.04802 14.5364 9.35742 14.8623C9.59924 15.117 9.87875 15.2954 10.0986 15.4004L10.2959 15.4814L10.6172 15.5879L10.7686 15.8916C11.3737 17.1018 12.9318 19.2023 15.1387 20.2441C15.96 20.6319 16.8646 20.8701 17.8447 20.8701C18.8238 20.87 19.7079 20.6329 20.4971 20.249C22.6197 19.2164 24.0365 17.1317 24.5625 15.9297L24.6816 15.6582L24.9463 15.5254C25.2082 15.3944 25.6321 15.1126 25.9795 14.7305C26.3293 14.3457 26.5311 13.9403 26.5312 13.542C26.5312 12.4582 25.9892 11.9205 25.877 11.8457L25.5127 11.6035V9.80762C25.5127 9.45716 25.4771 9.04136 25.3916 8.58887C25.3028 8.11876 25.1614 7.61498 24.9551 7.10938C24.8035 6.73792 24.6176 6.36638 24.3926 6.00684C24.1095 5.55456 23.7641 5.12171 23.3486 4.72852C22.9077 4.31126 22.3836 3.93581 21.7617 3.63086C20.7581 3.13879 19.477 2.81842 17.8447 2.81836C16.4015 2.81836 15.219 3.06841 14.2529 3.46777C13.4495 3.79989 12.784 4.23967 12.2344 4.73926C11.7982 5.13573 11.4318 5.57292 11.127 6.02832C10.8847 6.39022 10.6812 6.76354 10.5127 7.13672C10.3426 7.51346 10.2092 7.88944 10.1064 8.25098C9.93893 8.84076 9.85738 9.38586 9.83691 9.8291V11.7549ZM27.1494 10.7959C27.6472 11.3105 28.167 12.2401 28.167 13.542C28.1669 14.5012 27.6891 15.2835 27.1904 15.832C26.7875 16.2751 26.324 16.6177 25.9414 16.8438C25.2423 18.2925 23.6458 20.5362 21.2129 21.7197C20.2254 22.2 19.0981 22.5068 17.8447 22.5068C16.5918 22.5068 15.4492 22.2013 14.4395 21.7246C11.9634 20.5556 10.2415 18.3431 9.45117 16.9023C9.04937 16.7187 8.57913 16.4191 8.1709 15.9893C7.63179 15.4214 7.18176 14.6054 7.18164 13.542C7.18164 12.1553 7.6311 11.2081 8.2002 10.7168V9.79004L8.20117 9.77246C8.22634 9.19363 8.32976 8.51654 8.53223 7.80371C8.65571 7.36904 8.8166 6.91762 9.02148 6.46387C9.22462 6.01403 9.47147 5.56053 9.76758 5.11816C10.1404 4.56128 10.5917 4.02105 11.1338 3.52832C11.8189 2.9056 12.6444 2.36264 13.6279 1.95605C14.8114 1.46683 16.2087 1.18164 17.8447 1.18164C19.6962 1.1817 21.2284 1.54721 22.4824 2.16211C23.2567 2.54177 23.9163 3.01263 24.4736 3.54004C24.9976 4.03597 25.4288 4.57874 25.7793 5.13867C26.0577 5.58349 26.2854 6.03954 26.4697 6.49121C26.7203 7.1052 26.8913 7.71494 26.999 8.28516C27.1025 8.83282 27.1494 9.35028 27.1494 9.80762V10.7959Z" fill="#DEDEDE"/>
<path d="M20.6947 26.4038C20.6947 26.6875 20.6344 26.9888 20.5139 27.3079C20.4004 27.627 20.2232 27.9532 19.9821 28.2865C19.7481 28.6126 19.4503 28.9388 19.0886 29.265C18.7341 29.5912 18.3122 29.9032 17.8229 30.201C17.7662 30.2365 17.7272 30.2896 17.7059 30.3605C17.6917 30.4244 17.7343 30.4598 17.8335 30.4669C18.2164 30.4953 18.5958 30.4775 18.9716 30.4137C19.3545 30.3499 19.6807 30.2896 19.9502 30.2329C20.1913 30.1833 20.4146 30.1904 20.6203 30.2542C20.833 30.318 20.9783 30.474 21.0563 30.7222C21.1273 30.9562 21.106 31.1654 20.9925 31.3497C20.8862 31.5341 20.7302 31.6724 20.5245 31.7645C20.3756 31.8284 20.1948 31.8851 19.9821 31.9347C19.7764 31.9844 19.5602 32.0234 19.3333 32.0517C19.1134 32.0872 18.8936 32.112 18.6738 32.1262C18.454 32.1475 18.2554 32.1581 18.0782 32.1581C17.5676 32.1581 17.1103 32.1439 16.7061 32.1155C16.3019 32.0872 15.9473 32.0127 15.6424 31.8922C15.4439 31.8071 15.2914 31.6795 15.1851 31.5093C15.0858 31.3391 15.0255 31.1618 15.0043 30.9775C14.9901 30.7931 15.0113 30.6158 15.0681 30.4456C15.1319 30.2755 15.2241 30.1478 15.3446 30.0627C16.465 29.2969 17.3372 28.6197 17.9612 28.0312C18.5852 27.4426 18.8972 26.9463 18.8972 26.5421C18.8972 26.4499 18.8794 26.3577 18.844 26.2655C18.8156 26.1734 18.7553 26.0918 18.6632 26.0209C18.571 25.95 18.4433 25.8933 18.2803 25.8507C18.1172 25.8011 17.9009 25.7727 17.6314 25.7656C17.5393 25.7656 17.4258 25.7692 17.2911 25.7763C17.1634 25.7763 17.0252 25.7798 16.8763 25.7869C16.7344 25.794 16.5926 25.8011 16.4508 25.8082C16.309 25.8153 16.1849 25.8188 16.0785 25.8188C15.9651 25.8188 15.8623 25.794 15.7701 25.7444C15.6779 25.6947 15.5999 25.6274 15.5361 25.5423C15.4723 25.4572 15.4226 25.365 15.3872 25.2657C15.3517 25.1594 15.334 25.0565 15.334 24.9573C15.334 24.7445 15.3978 24.546 15.5254 24.3616C15.6602 24.1773 15.8481 24.0709 16.0892 24.0425C16.1743 24.0284 16.2842 24.0213 16.4189 24.0213C16.5607 24.0142 16.7025 24.0106 16.8443 24.0106C16.9933 24.0035 17.1351 24 17.2698 24C17.4116 24 17.5286 24 17.6208 24C18.2093 24 18.6986 24.0745 19.0886 24.2234C19.4857 24.3723 19.8013 24.5637 20.0353 24.7977C20.2763 25.0317 20.4465 25.2905 20.5458 25.5742C20.6451 25.8578 20.6947 26.1344 20.6947 26.4038Z" fill="#DEDEDE"/>
</svg>
    ),
  },
  {
    id: "grade3",
    name: "3학년 학생",
    icon: (
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.5801 33.2305C30.58 34.0572 29.9098 34.7275 29.083 34.7275H6.67871C5.85206 34.7274 5.18177 34.0571 5.18164 33.2305V30.6406C5.18166 28.9793 5.2828 27.0285 6.34082 25.417C8.51419 22.1069 12.5844 20.5776 14.6729 20.1807C15.1168 20.0963 15.5455 20.3881 15.6299 20.832C15.714 21.2758 15.4223 21.7038 14.9785 21.7881C13.0964 22.1457 9.53432 23.5337 7.70801 26.3154C6.94287 27.4811 6.81838 28.9798 6.81836 30.6406V33.0908H28.9443V32.1299C28.9443 29.5614 28.5091 27.0971 27.0195 25.2832C25.4738 23.401 23.3623 21.8029 20.8926 21.8027C20.4407 21.8027 20.0742 21.4362 20.0742 20.9844C20.0742 20.5325 20.4407 20.166 20.8926 20.166C24.0885 20.1662 26.6177 22.2159 28.2842 24.2451C30.1356 26.4999 30.58 29.4337 30.5801 32.1299V33.2305Z" fill="#DEDEDE"/>
<path d="M10.1286 5.57315C9.85933 5.97538 9.63433 6.38882 9.44846 6.80043C9.26086 7.21586 9.11312 7.62943 9 8.0277C11.5256 8.50745 17.4586 8.93364 20.9852 6.80043C21.246 7.20952 22.5894 8.10952 25.8764 8.43679C25.7782 7.91663 25.622 7.36022 25.3935 6.80043C25.2255 6.38882 25.0185 5.97538 24.7668 5.57315C24.4499 5.06696 24.0622 4.57854 23.5924 4.13391C23.0933 3.66157 22.5015 3.23865 21.8034 2.89634C20.6744 2.34276 19.2675 2 17.5253 2C15.9857 2 14.6964 2.26767 13.6216 2.71197C12.7281 3.08132 11.9829 3.57274 11.3655 4.13391C10.8763 4.57854 10.4674 5.06696 10.1286 5.57315Z" fill="#DEDEDE"/>
<path d="M9.83691 11.7549L9.27734 11.9414C9.40139 11.9001 8.81836 12.1052 8.81836 13.542C8.81847 14.1076 9.04802 14.5364 9.35742 14.8623C9.59924 15.117 9.87875 15.2954 10.0986 15.4004L10.2959 15.4814L10.6172 15.5879L10.7686 15.8916C11.3737 17.1018 12.9318 19.2023 15.1387 20.2441C15.96 20.6319 16.8646 20.8701 17.8447 20.8701C18.8238 20.87 19.7079 20.6329 20.4971 20.249C22.6197 19.2164 24.0365 17.1317 24.5625 15.9297L24.6816 15.6582L24.9463 15.5254C25.2082 15.3944 25.6321 15.1126 25.9795 14.7305C26.3293 14.3457 26.5311 13.9403 26.5312 13.542C26.5312 12.4582 25.9892 11.9205 25.877 11.8457L25.5127 11.6035V9.80762C25.5127 9.45716 25.4771 9.04136 25.3916 8.58887C25.3028 8.11876 25.1614 7.61498 24.9551 7.10938C24.8035 6.73792 24.6176 6.36638 24.3926 6.00684C24.1095 5.55456 23.7641 5.12171 23.3486 4.72852C22.9077 4.31126 22.3836 3.93581 21.7617 3.63086C20.7581 3.13879 19.477 2.81842 17.8447 2.81836C16.4015 2.81836 15.219 3.06841 14.2529 3.46777C13.4495 3.79989 12.784 4.23967 12.2344 4.73926C11.7982 5.13573 11.4318 5.57292 11.127 6.02832C10.8847 6.39022 10.6812 6.76354 10.5127 7.13672C10.3426 7.51346 10.2092 7.88944 10.1064 8.25098C9.93893 8.84076 9.85738 9.38586 9.83691 9.8291V11.7549ZM27.1494 10.7959C27.6472 11.3105 28.167 12.2401 28.167 13.542C28.1669 14.5012 27.6891 15.2835 27.1904 15.832C26.7875 16.2751 26.324 16.6177 25.9414 16.8438C25.2423 18.2925 23.6458 20.5362 21.2129 21.7197C20.2254 22.2 19.0981 22.5068 17.8447 22.5068C16.5918 22.5068 15.4492 22.2013 14.4395 21.7246C11.9634 20.5556 10.2415 18.3431 9.45117 16.9023C9.04937 16.7187 8.57913 16.4191 8.1709 15.9893C7.63179 15.4214 7.18176 14.6054 7.18164 13.542C7.18164 12.1553 7.6311 11.2081 8.2002 10.7168V9.79004L8.20117 9.77246C8.22634 9.19363 8.32976 8.51654 8.53223 7.80371C8.65571 7.36904 8.8166 6.91762 9.02148 6.46387C9.22462 6.01403 9.47147 5.56053 9.76758 5.11816C10.1404 4.56128 10.5917 4.02105 11.1338 3.52832C11.8189 2.9056 12.6444 2.36264 13.6279 1.95605C14.8114 1.46683 16.2087 1.18164 17.8447 1.18164C19.6962 1.1817 21.2284 1.54721 22.4824 2.16211C23.2567 2.54177 23.9163 3.01263 24.4736 3.54004C24.9976 4.03597 25.4288 4.57874 25.7793 5.13867C26.0577 5.58349 26.2854 6.03954 26.4697 6.49121C26.7203 7.1052 26.8913 7.71494 26.999 8.28516C27.1025 8.83282 27.1494 9.35028 27.1494 9.80762V10.7959Z" fill="#DEDEDE"/>
<path d="M18.1632 26.0265C18.0994 26.0265 17.993 26.03 17.8441 26.0371C17.7023 26.0371 17.5463 26.0407 17.3761 26.0478C17.2059 26.0548 17.0357 26.0619 16.8655 26.069C16.6954 26.0761 16.5571 26.0797 16.4507 26.0797C16.3444 26.0797 16.2451 26.0584 16.1529 26.0158C16.0678 25.9662 15.9898 25.9024 15.9189 25.8244C15.848 25.7393 15.7913 25.6471 15.7487 25.5478C15.7133 25.4415 15.6955 25.3351 15.6955 25.2288C15.6884 25.1224 15.7026 25.0196 15.7381 24.9203C15.7806 24.821 15.8338 24.7288 15.8976 24.6438C15.9685 24.5587 16.0501 24.4878 16.1423 24.431C16.2415 24.3743 16.3479 24.3353 16.4614 24.314C16.5464 24.2998 16.6741 24.2892 16.8443 24.2821C17.0144 24.275 17.1917 24.2715 17.3761 24.2715C17.5675 24.2715 17.7448 24.2715 17.9079 24.2715C18.071 24.2715 18.188 24.2715 18.2589 24.2715C18.6985 24.2715 19.1027 24.3176 19.4714 24.4098C19.8402 24.4948 20.1557 24.6296 20.4181 24.8139C20.6875 24.9912 20.8967 25.2181 21.0456 25.4947C21.2016 25.7712 21.2796 26.0938 21.2796 26.4626C21.2796 26.9164 21.1591 27.2922 20.918 27.59C20.684 27.8878 20.3543 28.0793 19.9288 28.1644C20.177 28.1928 20.4004 28.2601 20.5989 28.3665C20.8045 28.4658 20.9783 28.5969 21.1201 28.76C21.2619 28.916 21.3718 29.1004 21.4498 29.3131C21.5349 29.5258 21.5774 29.7598 21.5774 30.0151C21.5774 30.4264 21.4924 30.788 21.3222 31.1C21.1591 31.412 20.9251 31.6744 20.6202 31.8871C20.3224 32.0998 19.9643 32.2594 19.5459 32.3658C19.1346 32.4792 18.6808 32.5359 18.1844 32.5359C17.9859 32.5359 17.7803 32.5253 17.5675 32.504C17.3548 32.4898 17.1456 32.465 16.94 32.4296C16.7414 32.3941 16.55 32.348 16.3656 32.2913C16.1884 32.2346 16.0288 32.1672 15.887 32.0892C15.6955 31.9828 15.5573 31.8481 15.4722 31.685C15.3942 31.5148 15.3906 31.2986 15.4615 31.0362C15.5041 30.8873 15.5714 30.7703 15.6636 30.6852C15.7558 30.593 15.8551 30.5257 15.9614 30.4831C16.0749 30.4406 16.1848 30.4193 16.2912 30.4193C16.4046 30.4193 16.4968 30.437 16.5677 30.4725C16.7308 30.5363 16.9577 30.6037 17.2484 30.6746C17.5463 30.7384 17.8476 30.7703 18.1525 30.7703C18.4574 30.7703 18.7127 30.7455 18.9184 30.6958C19.1311 30.6462 19.3013 30.5824 19.4289 30.5044C19.5565 30.4264 19.6452 30.3342 19.6948 30.2278C19.7515 30.1144 19.7799 30.0009 19.7799 29.8875C19.7799 29.7811 19.7622 29.6818 19.7267 29.5897C19.6984 29.4904 19.631 29.4088 19.5246 29.345C19.4254 29.2741 19.28 29.2174 19.0885 29.1748C18.8971 29.1323 18.6383 29.111 18.3121 29.111H16.6103C16.4259 29.111 16.2557 29.0366 16.0997 28.8877C15.9508 28.7317 15.8764 28.5118 15.8764 28.2282C15.8764 28.1077 15.8941 27.9942 15.9295 27.8878C15.9721 27.7744 16.0288 27.6787 16.0997 27.6007C16.1706 27.5156 16.2486 27.4518 16.3337 27.4092C16.4259 27.3596 16.5181 27.3348 16.6103 27.3348H18.227C18.6808 27.3348 19.0034 27.2851 19.1949 27.1858C19.3934 27.0795 19.4927 26.8987 19.4927 26.6434C19.4927 26.5512 19.4714 26.4697 19.4289 26.3988C19.3934 26.3208 19.3225 26.2569 19.2162 26.2073C19.1169 26.1506 18.9822 26.108 18.812 26.0797C18.6418 26.0442 18.4255 26.0265 18.1632 26.0265Z" fill="#DEDEDE"/>
</svg>
    ),
  },
  {
    id: "teachers",
    name: "교직원",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32.8389 14.0273C33.3392 18.3607 30.5396 27.0273 23.3396 27.0273C19.0414 27.0273 16.1244 23.9388 14.5857 20.5273C13.6618 18.479 13.2348 16.3143 13.3041 14.6318"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M26.8402 8.52734C27.6402 12.1273 31.5069 14.694 33.3402 15.0273C33.6736 10.8607 32.1402 2.52734 23.3402 2.52734C14.5402 2.52734 13.0069 10.8607 13.3402 15.0273C14.5402 15.4273 16.1736 12.194 16.8402 11.5273C21.6402 12.3273 25.5069 10.194 26.8402 8.52734Z"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M18.3398 25.0273V28.0273M18.3398 28.0273L22.4379 31.0273M18.3398 28.0273C17.701 28.1385 16.9556 28.3042 16.157 28.5273M22.4379 31.0273L27.3398 28.0273M22.4379 31.0273L19.8398 37.5273M22.4379 31.0273L24.8398 37.5273M27.3398 28.0273V26.0273M27.3398 28.0273C28.0431 28.0273 28.7093 28.0671 29.3398 28.1415M19.8398 37.5273L16.157 28.5273M19.8398 37.5273C19.8398 37.5273 21.3095 41.5329 22.4379 41.5273C23.2001 41.5236 24.8398 37.5273 24.8398 37.5273M24.8398 37.5273L29.3398 28.1415M16.157 28.5273C15.6456 28.6702 15.1124 28.8367 14.5714 29.0273C10.8876 30.3257 6.83984 32.749 6.83984 36.5273V41.5273H39.3398V36.5273C38.9165 34.1285 36.6294 29.6986 30.8398 28.3964C30.3638 28.2893 29.8641 28.2034 29.3398 28.1415"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M16.8398 17.0273C16.8398 18.4081 17.9591 19.5273 19.3398 19.5273C20.7206 19.5273 21.8398 18.4081 21.8398 17.0273C21.8398 15.6466 20.7206 14.5273 19.3398 14.5273C17.9591 14.5273 16.8398 15.6466 16.8398 17.0273ZM16.8398 17.0273L13.8398 17.5273"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M29.8398 17.0273C29.8398 18.4081 28.7206 19.5273 27.3398 19.5273C25.9591 19.5273 24.8398 18.4081 24.8398 17.0273M29.8398 17.0273C29.8398 15.6466 28.7206 14.5273 27.3398 14.5273C25.9591 14.5273 24.8398 15.6466 24.8398 17.0273M29.8398 17.0273L32.3398 17.5273M24.8398 17.0273H21.8398"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M12.8398 15.0273C11.183 15.0273 9.83984 16.3705 9.83984 18.0273C9.83984 19.6842 11.183 21.0273 12.8398 21.0273C13.2625 21.0273 13.6647 20.9399 14.0295 20.7822"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M33.0293 15.0273C34.6862 15.0273 36.0293 16.3705 36.0293 18.0273C36.0293 19.6842 34.6862 21.0273 33.0293 21.0273C32.6066 21.0273 32.2044 20.9399 31.8397 20.7822"
          stroke="#666666"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  {
    id: "parents",
    name: "학부모",
    icon: (
      <svg
        width="45"
        height="45"
        viewBox="0 0 45 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.1139 26.0273C15.278 24.1183 14.4465 21.2805 14.2402 19.5273V15.5273C18.6402 15.9273 22.0736 12.0273 23.2402 10.0273C23.6402 13.2273 27.0736 15.0273 28.7402 15.5273V19.5273C28.6371 21.2805 27.9725 24.1183 26.2489 26.0273M17.1139 26.0273C18.2452 27.2037 19.7577 28.0273 21.7402 28.0273C23.7228 28.0273 25.1869 27.2037 26.2489 26.0273M17.1139 26.0273C17.156 27.0273 16.9402 29.3273 15.7402 30.5273M15.7402 30.5273C16.4069 32.0273 18.5402 35.0273 21.7402 35.0273C24.9402 35.0273 26.7402 32.0273 27.2402 30.5273M15.7402 30.5273C14.527 30.5912 12.8489 30.8997 11.2402 31.5935M27.2402 30.5273C26.746 29.694 25.8558 27.6273 26.2489 26.0273M27.2402 30.5273C29.2726 30.5273 30.9173 30.863 32.2402 31.4081M11.2402 31.5935C8.65022 32.7105 6.24023 34.8261 6.24023 38.5273V41.5273H37.2402V38.5273C37.2718 36.5297 36.1904 33.0356 32.2402 31.4081M11.2402 31.5935C10.5736 30.5714 9.54023 27.1273 10.7402 21.5273C12.2402 14.5273 9.24023 11.5273 15.2402 5.52734C15.904 4.86068 18.1333 3.52734 21.7402 3.52734C26.2489 3.52734 30.2402 6.52734 31.2402 10.0273C32.2402 13.5273 31.7402 19.5273 32.7402 21.0273C33.7402 22.5273 34.7402 29.2888 32.2402 31.4081"
          stroke="#666666"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "all",
    name: "전체 사용자",
    icon: (
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="9.37891"
          y="5.52734"
          width="31.061"
          height="31.061"
          rx="3.40813"
          stroke="#666666"
          strokeWidth="2"
        />
        <path
          d="M20.8712 24.3296H17.2572L16.6592 26.0586H14.7482L18.0112 16.9716H20.1302L23.3932 26.0586H21.4692L20.8712 24.3296ZM20.3772 22.8736L19.0642 19.0776L17.7512 22.8736H20.3772ZM26.0428 24.6156H29.0328V26.0586H24.2228V16.9846H26.0428V24.6156ZM31.6196 24.6156H34.6096V26.0586H29.7996V16.9846H31.6196V24.6156Z"
          fill="#666666"
        />
        <path
          d="M31.1535 40.5266H27.4801H20.1332H11.317C8.0709 40.5266 5.43945 37.8951 5.43945 34.6491V25.8328V18.4859V14.8125"
          stroke="#666666"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const messages = [
  {
    id: 1,
    translate:
      "[가정통신문] 2025학년도 여름철 물놀이 안전 수칙 및 화재 대피 요령 안내",
    original: "작성자 : 김미정 | 등록일 : 2025-07-14 10:11:21",
  },
  {
    id: 2,
    translate: "[가정통신문] 2025학년도 3학년 졸업앨범 주요 내용 안내",
    original: "작성자 : 김미정 | 등록일 : 2025-07-11 13:29:03",
  },
  {
    id: 3,
    translate: "[공지사항] 2025 기후과학클래스 3기 참가자 모집 안내 ",
    original: "작성자 : 강민희 | 등록일 : 2025-07-04 08:13:28",
  },
  {
    id: 4,
    translate:
      "[공지사항] 2025학년도 융합과학교육원 본원 메이커 발명 캠프 신청 안내",
    original: "작성자 : 장익환 | 등록일 : 2025-07-03 17:18:44",
  },
  {
    id: 5,
    translate:
      "[공지사항] 2025학년도 한성과학고등학교 발명교육센터 발명심화 ・ 특별과정 모집 안내",
    original: "작성자 : 장익환 | 등록일 : 2025-07-01 13:26:12",
  },
];

const PageCreateEducationContent = () => {
  const navigate = useNavigate();

  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice] = useAtom(AUTODISPLAY_SELECTED_DEVICE);
  const [autoDisplayDesignGenerator, setAutoDisplayDesignGenerator] = useAtom(
    AUTODISPLAY_DESIGN_GENERATOR
  );
  // UI 상태 관리
  const [showPopupSave, setShowPopupSave] = useState(false);
  const [showPopupError, setShowPopupError] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [businessDescription, setBusinessDescription] = useState("");
  const [contentTarget, setContentTarget] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingReport, setIsLoadingReport] = useState(false);
  const [showPopupFileSize, setShowPopupFileSize] = useState(false);
  const [toolSteps, setToolSteps] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [interviewModeType, setInterviewModeType] = useState("conceptBoard");
  const [isLoadingPreset, setIsLoadingPreset] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showCreatePersonaPopup, setShowCreatePersonaPopup] = useState(false);
  const [showCreditPopup, setShowCreditPopup] = useState(false);
  const [selectedDesignConcepts, setSelectedDesignConcepts] = useState([]);
  const [dropUpStates, setDropUpStates] = useState({
    customerList: false,
  });
  const [selectBoxStates, setSelectBoxStates] = useState({
    customerList: false,
  });
  const [selectedPurposes, setSelectedPurposes] = useState({
    customerList: "",
  });
  const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
  const [showTemplateSelection, setShowTemplateSelection] = useState(false);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showTemplatePreview, setShowTemplatePreview] = useState(false);
  const [templateToPreview, setTemplateToPreview] = useState(null);
  const [autoDisplayFileAnalysis, setAutoDisplayFileAnalysis] = useState(null);
  const [timeStamp, setTimeStamp] = useState(null);
  const [allDesignResponses, setAllDesignResponses] = useState([]); // 모든 디자인 응답 저장
  const [selectedTemplateData, setSelectedTemplateData] = useState(null);
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);

  const [
    autoDisplayContentGeneratorMarkdown,
    setAutoDisplayContentGeneratorMarkdown,
  ] = useState([]);
  const [
    autoDisplayContentGeneratorTitle,
    setAutoDisplayContentGeneratorTitle,
  ] = useState([]);
  const [autoDisplayContentGeneratorJson, setAutoDisplayContentGeneratorJson] =
    useState(null);
  const [contentsPurpose, setContentsPurpose] = useState(null);

  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedTargetAudience, setSelectedTargetAudience] = useState([]);

  // 템플릿 데이터
  const templateData = [
    // {
    //   id: 1,
    //   title: "고대비 밝은 양식 디자인",
    //   description: "밝고 간결하게 정보를 전달하는 기본형 디자인 ",
    //   category: "모던 게시판형",
    //   image: "/images/template1.jpg", // 실제 이미지 경로로 변경
    //   location: "4층 도서자료실(지금실내네비)",
    // },
    // {
    //   id: 2,
    //   title: "심플한 직관 양식 디자인",
    //   description: "시선을 집중시키는 어두운 배경의 정보전달형 디자인 ",
    //   category: "심플 플로우형",
    //   image: "/images/template2.jpg", // 실제 이미지 경로로 변경
    //   location: "4층 도서자료실(지금실내네비)",
    // },
    // {
    //   id: 3,
    //   title: "아이콘 인포그래픽 양식 디자인",
    //   description: "부드럽고 신뢰감 있는 분위기의 파란색 계열 디자인 ",
    //   category: "엥글 보드형",
    //   image: "/images/template3.jpg", // 실제 이미지 경로로 변경
    //   location: "4층 도서자료실(지금실내네비)",
    // },
  ];

  useDynamicViewport("width=1280");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);
      const lastUrl = sessionStorage.getItem("lastUrl");

      if (
        (lastUrl === "/CreateApiContent" || lastUrl === "/ApiDashBoard") &&
        userMemberType.member_type === 99
      ) {
        navigate("/Admin");
      }

      if (userMemberType.member_type === 11) {
        navigate("/DashBoard");
      } else if (userMemberType.member_type === 12) {
        navigate("/CustomerManage");
      } else if (userMemberType.member_type === 21) {
        navigate("/ApiDashBoard");
      } else if (userMemberType.member_type === 22) {
        navigate("/CustomerManage");
      }
    };

    checkMemberType();
  }, []);

  useEffect(() => {
    if (showToast) {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0";
    };
  }, [showToast]);

  const handleNextStep = (currentStep) => {
    setCompletedSteps([...completedSteps, currentStep]);
    setActiveTab(currentStep + 1);
    setShowPopupError(false);
  };

  const abortControllerRef = useRef(null);

  const handleSubmitConcept = async () => {
    if (autoDisplayFileAnalysis) {
      handleNextStep(1);
      return;
    }
    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;
    const timeStamp = new Date().getTime();
    setTimeStamp(timeStamp);
    // 2초 후 다음 단계로 이동 (API 호출 시뮬레이션)'
    handleNextStep(1);
    setToolSteps(2);
    setIsLoading(true);

    let response;

    try {
      if (interviewModeType === "conceptBoard") {
        // 파일 업로드를 통한 콘텐츠 생성
        const Data = {
          display_id: selectedDevice._id,
          files: uploadedFiles,
          time_stamp: String(timeStamp),
        };

        setFileNames(uploadedFiles.map((file) => file.name));

        let retryCount = 0;
        const maxRetries = 5;
        while (retryCount < maxRetries) {
          try {
            // 콘텐츠 생성을 위한 멀티모달 요청
            response = await AutoDisplayFileAnalysisMultimodalRequest(
              Data,
              isLoggedIn,
              signal
            );

            if (
              response &&
              response.response &&
              response.response.auto_display_file_analysis_multimodal &&
              response.response.auto_display_file_analysis_multimodal.title &&
              response.response.auto_display_file_analysis_multimodal.status &&
              response.response.auto_display_file_analysis_multimodal.detail &&
              response.response.auto_display_file_analysis_multimodal.message
            ) {
              // setAutoDisplayFileAnalysisMultimodal(
              //   response.response.auto_display_file_analysis_multimodal
              // );
              setAutoDisplayFileAnalysis(
                response.response.auto_display_file_analysis_multimodal
              );
              break; // 올바른 응답 형식이면 루프 종료
            }

            retryCount++;
          } catch (error) {
            console.error(`Retry ${retryCount + 1} failed:`, error);
            retryCount++;
            if (retryCount >= maxRetries) throw error;
          }
        }

        if (retryCount >= maxRetries) {
          throw new Error("콘텐츠 분석에 실패했습니다. 다시 시도해주세요.");
        }
      } else {
        // 텍스트만으로 콘텐츠 생성
        const Data = {
          type: "auto_display_file_analysis",
          input_text: businessDescription,
        };

        let retryCount = 0;
        const maxRetries = 5;

        while (retryCount < maxRetries) {
          try {
            response = await AutoDisplayFileAnalysisRequest(Data, isLoggedIn);

            if (
              response &&
              response.response &&
              response.response.auto_display_file_analysis &&
              response.response.auto_display_file_analysis.title &&
              response.response.auto_display_file_analysis.status &&
              response.response.auto_display_file_analysis.detail &&
              response.response.auto_display_file_analysis.message
            ) {
              // API 응답 데이터를 상태에 저장
              setAutoDisplayFileAnalysis(
                response.response.auto_display_file_analysis
              );
              break; // 올바른 응답 형식이면 루프 종료
            }

            retryCount++;
          } catch (error) {
            console.error(`Retry ${retryCount + 1} failed:`, error);
            retryCount++;
            if (retryCount >= maxRetries) throw error;
          }
        }

        if (retryCount >= maxRetries) {
          throw new Error("텍스트 분석에 실패했습니다. 다시 시도해주세요.");
        }
      }
    } catch (error) {
      console.error("콘텐츠 분석 중 오류 발생:", error);
      setShowPopupError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTargetAudienceSelect = (audienceId) => {
    if (completedSteps.includes(2)) return;
    setSelectedTargetAudience((prev) => {
      const grades = ["gradeX", "grade2", "grade3"];
      const allGradesId = "allGrades";
      let newSelected = prev.includes(audienceId)
        ? prev.filter((id) => id !== audienceId)
        : [...prev, audienceId];

      if (grades.includes(audienceId)) {
        // 학년 토글
        if (grades.every(g => newSelected.includes(g))) {
          // 모두 선택됨, 전교생 추가
          if (!newSelected.includes(allGradesId)) newSelected.push(allGradesId);
        } else {
          // 하나라도 없음, 전교생 제거
          newSelected = newSelected.filter(id => id !== allGradesId);
        }
      } else if (audienceId === allGradesId) {
        if (newSelected.includes(allGradesId)) {
          // 전교생 선택, 학년 모두 추가
          grades.forEach(g => { if (!newSelected.includes(g)) newSelected.push(g); });
        } else {
          // 전교생 해제, 학년 모두 제거
          newSelected = newSelected.filter(id => !grades.includes(id));
        }
      }

      const selectedOptions = targetAudienceOptions.filter((option) =>
        newSelected.includes(option.id)
      );

      if (newSelected.includes(allGradesId)) {
        setContentTarget(["전교생"]);
      } else {
        setContentTarget(selectedOptions.map((opt) => opt.name));
      }
      return newSelected;
    });
  };

  const handleSubmitPurpose = async (isRegenerate = false) => {
    if (autoDisplayContentGeneratorMarkdown.length > 0 && !isRegenerate) {
      handleNextStep(2);
      return;
    }
    handleNextStep(2);
    setIsLoading(true);

    try {
      let data;
      let allResponsesMarkdown = [];
      let allResponsesTitle = [];
      if (
        interviewModeType === "conceptBoard"
        // || interviewModeType === "article"
      ) {
        // 파일 업로드 모드 - 파일과 함께 전송
        data = {
          type: "ad_education_content_multimodal", // 필수
          // display_id: selectedDevice?._id || "", // 선택된 디스플레이 ID
          upload_files: uploadedFiles.map((file, index) => ({
            id: "file_" + timeStamp + "_" + (index + 1),
            name: file.name,
          })),
          // time_stamp: String(timeStamp),
          display_info: {
            width: selectedDevice?.deviceSpec?.deviceWidth || "1920",
            height: selectedDevice?.deviceSpec?.deviceHeight || "1080",
            resolution: selectedDevice?.deviceSpec?.deviceDPI || "Full HD",
          },
          info_summary: {
            title: autoDisplayFileAnalysis?.title || "",
            source: autoDisplayFileAnalysis?.source || "",
            message: autoDisplayFileAnalysis?.message || "",
            detail: autoDisplayFileAnalysis?.detail || "",
          },
          content_target: (() => {
            const grades = ["gradeX", "grade2", "grade3"];
            const allGradesId = "allGrades";
            // 전교생이 선택되어 있고 학년들이 모두 선택되어 있다면 전교생만 전송
            if (selectedTargetAudience.includes(allGradesId) && grades.every(g => selectedTargetAudience.includes(g))) {
              return ["전교생"];
            }
            // 그렇지 않으면 선택된 옵션들의 이름을 반환
            const selectedOptions = targetAudienceOptions.filter((option) =>
              selectedTargetAudience.includes(option.id)
            );
            return selectedOptions.map((opt) => opt.name);
          })(),
        };
      } else if (interviewModeType === "explanation") {
        // 텍스트 입력 모드 - 텍스트만 전송
        data = {
          type: "ad_education_content_generator", // 필수
          input_text: businessDescription,
          display_info: {
            width: selectedDevice?.deviceSpec?.deviceWidth || "1920",
            height: selectedDevice?.deviceSpec?.deviceHeight || "1080",
            resolution: selectedDevice?.deviceSpec?.deviceDPI || "Full HD",
          },
          info_summary: {
            title: autoDisplayFileAnalysis?.title || "",
            source: autoDisplayFileAnalysis?.source || "",
            message: autoDisplayFileAnalysis?.message || "",
            detail: autoDisplayFileAnalysis?.detail || "",
          },
          content_target: (() => {
            const grades = ["gradeX", "grade2", "grade3"];
            const allGradesId = "allGrades";
            // 전교생이 선택되어 있고 학년들이 모두 선택되어 있다면 전교생만 전송
            if (selectedTargetAudience.includes(allGradesId) && grades.every(g => selectedTargetAudience.includes(g))) {
              return ["전교생"];
            }
            // 그렇지 않으면 선택된 옵션들의 이름을 반환
            const selectedOptions = targetAudienceOptions.filter((option) =>
              selectedTargetAudience.includes(option.id)
            );
            return selectedOptions.map((opt) => opt.name);
          })(),
        };
      }

      let retryCount = 0;
      const maxRetries = 10;

      while (retryCount < maxRetries) {
        try {
          let response = await AutoDisplayContentGeneratorRequest(
            data,
            isLoggedIn
          );

          if (
            response &&
            response.response &&
            response.response.ad_education_content_generator
          ) {
            allResponsesMarkdown.push(
              response.response.ad_education_content_generator.sections
                .section_first
            );
            allResponsesMarkdown.push(
              response.response.ad_education_content_generator.sections
                .section_second
            );
            allResponsesTitle.push(
              response.response.ad_education_content_generator.title
            );

            // if (selectedDesignConcepts[i] === "모던 게시판형") {
            //   setAutoDisplayContentGeneratorJson(
            //     response.response.ad_education_content_generator_json
            //   );
            // }
            break; // 올바른 응답 형식이면 루프 종료
          }

          retryCount++;
        } catch (error) {
          console.error(`Retry ${retryCount + 1} failed:`, error);
          retryCount++;
          if (retryCount >= maxRetries) throw error;
        }
      }

      if (retryCount >= maxRetries) {
        throw new Error("텍스트 분석에 실패했습니다. 다시 시도해주세요.");
      }

      setAutoDisplayContentGeneratorMarkdown(allResponsesMarkdown);
      setAutoDisplayContentGeneratorTitle(allResponsesTitle);

      console.log(allResponsesMarkdown);
      console.log(autoDisplayContentGeneratorJson);

      setToolSteps(3);
      setCompletedSteps((prev) => [...prev, 3]);
    } catch (error) {
      console.error("콘텐츠 분석 중 오류 발생:", error);
      setShowPopupError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeStatus = ({ meta, file, remove }, status) => {
    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize && status !== "removed") {
      setShowPopupFileSize(true);
      remove();
      return;
    }

    if (status === "done" || status === "preparing" || status === "uploading") {
      setUploadedFiles((prev) => {
        if (!prev.find((f) => f.name === file.name)) {
          setFileNames((prev) => [...prev, file.name]);
          return [...prev, file];
        }
        return prev;
      });
    } else if (status === "removed") {
      setUploadedFiles((prev) => prev.filter((f) => f.name !== file.name));
      setFileNames((prev) => prev.filter((name) => name !== file.name));
    }

    const size = file.size;
    const sizeStr =
      size > 1024 * 1024
        ? `${(size / (1024 * 1024)).toFixed(1)}MB`
        : `${(size / 1024).toFixed(1)}KB`;

    setTimeout(() => {
      const containers = document.querySelectorAll(".dzu-previewContainer");
      containers.forEach((container) => {
        if (!container.dataset.filename) {
          container.dataset.filename = file.name;
          container.dataset.size = sizeStr;

          if (file.type.startsWith("image/")) {
            if (!container.querySelector(".dzu-previewFileName")) {
              const nameSpan = document.createElement("span");
              nameSpan.className = "dzu-previewFileName";
              nameSpan.textContent = `${file.name}, ${sizeStr}`;

              if (container.firstChild) {
                container.insertBefore(nameSpan, container.firstChild);
              } else {
                container.appendChild(nameSpan);
              }
            }
          }
        }
      });
    }, 0);
  };

  const handleConfirmCredit = async () => {
    setShowCreatePersonaPopup(false);
  };

  const handleDesignConceptSelect = (conceptId) => {
    // 4단계가 완료된 후에는 디자인 선택을 변경할 수 없음
    if (completedSteps.includes(4)) {
      return;
    }
    
    setSelectedDesignConcepts((prev) => {
      if (prev.includes(conceptId)) {
        return [];
      } else {
        return [conceptId];
      }
    });
  };

  const handleDisplayConversion = async () => {
    // 4단계가 완료된 후에는 디스플레이 변환을 다시 실행할 수 없음
    if (completedSteps.includes(4)) {
      return;
    }
    
    // 콘텐츠 제목이 비어있으면 진행하지 않음
    if (!autoDisplayFileAnalysis?.title || autoDisplayFileAnalysis.title.trim() === '') {
      // 에러 메시지 표시 또는 사용자에게 알림
      return;
    }

    setIsLoadingTemplate(true);

    setTimeout(() => {
      setShowTemplateSelection(true);
      setIsLoadingTemplate(false);
    }, 5000);
  };

  const handleTemplatePreview = (template) => {
    setTemplateToPreview(template);
    console.log(
      "미리보기 시점의 selectedPurposes.customerList:",
      selectedPurposes.customerList
    );
    setContentsPurpose(selectedPurposes.customerList); // 미리보기 시점에서 contentsPurpose 설정
    setShowTemplatePreview(true);
  };

  const handleCloseTemplatePreview = () => {
    setShowTemplatePreview(false);
    setTemplateToPreview(null);
  };

  const handleConfirmContent = async () => {
    // 4단계가 이미 완료된 경우 바로 4단계로 이동
    if (completedSteps.includes(4)) {
      setActiveTab(4);
      return;
    }
    
    handleNextStep(3);
    setToolSteps(4);
    // 4단계도 즉시 완료 처리하여 화면실행 탭 활성화
    setTimeout(() => {
      setCompletedSteps(prev => [...prev, 4]);
    }, 100);

    try {
      const createViewId = await createEduViewOnServer(isLoggedIn);

      let finalMarkdown = null;
      let finalTitle = null;
      let finalJson = null;

      finalMarkdown = autoDisplayContentGeneratorMarkdown;
      finalTitle = autoDisplayContentGeneratorTitle[0];

      // 데이터를 조합하여 contentData 객체 생성
      const now = new Date();
      const contentData = {
        viewDevice: {
          _id: selectedDevice?._id || "",
          deviceTitle: selectedDevice?.deviceTitle || "",
          deviceDPI: selectedDevice?.deviceSpec?.deviceDPI || "",
          deviceInch: selectedDevice?.deviceSpec?.deviceInch || "",
          deviceCm: selectedDevice?.deviceSpec?.deviceCm || "",
          deviceWidth: selectedDevice?.deviceSpec?.deviceWidth || "",
          deviceHeight: selectedDevice?.deviceSpec?.deviceHeight || "",
        },
        uploadFileData: uploadedFiles.map((file, index) => ({
          id: "file_" + timeStamp + "_" + (index + 1),
          name: file.name,
        })),
        textData: businessDescription,
        dataAnalysis: {
          title: autoDisplayFileAnalysis?.title || "",
          source: autoDisplayFileAnalysis?.source || "",
          message: autoDisplayFileAnalysis?.message || "",
          detail: autoDisplayFileAnalysis?.detail || "",
        },
        designConcept: selectedDesignConcepts[0],
        contentsType: "general",
        contentsTarget: (() => {
          const grades = ["gradeX", "grade2", "grade3"];
          const allGradesId = "allGrades";
          // 전교생이 선택되어 있고 학년들이 모두 선택되어 있다면 전교생만 저장
          if (selectedTargetAudience.includes(allGradesId) && grades.every(g => selectedTargetAudience.includes(g))) {
            return ["전교생"];
          }
          // 그렇지 않으면 선택된 옵션들의 이름을 반환
          const selectedOptions = targetAudienceOptions.filter((option) =>
            selectedTargetAudience.includes(option.id)
          );
          return selectedOptions.map((opt) => opt.name);
        })(),
        contentGeneratorMarkdown: finalMarkdown,
        contentGeneratorJson: finalJson,
        contentGeneratorTitle: finalTitle,
        createDate: now.toLocaleString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
        createTimestamp: now.getTime(),
      };
      if (customerId !== "") {
        contentData.customer = customerId;
      }
      setContentsPurpose(selectedPurposes.customerList);
      console.log(
        "selectedPurposes.customerList",
        selectedPurposes.customerList
      );
      await updateEduViewOnServer(createViewId, contentData);

      // setAutoDisplaySelectedContent(createViewId);
      // navigate("/DashBoard");
    } catch (error) {
      console.error("콘텐츠 확인 또는 업데이트 실패:", error);
    }
  };

  useEffect(() => {
    // 새로고침 감지 함수
    const detectRefresh = () => {
      // 현재 URL 확인
      const currentUrl = window.location.href;
      if (currentUrl.toLowerCase().includes("createeducationcontent")) {
        // 세션 스토리지에서 마지막 URL 가져오기
        const lastUrl = sessionStorage.getItem("lastUrl");

        // 마지막 URL이 현재 URL과 같으면 새로고침
        if (lastUrl && lastUrl === currentUrl) {
          // if (customerId !== "") {
          //   navigate("/EduboardManage");
          // } else {
            navigate("/EducationDashBoard");
          // }
          return true;
        }

        // 현재 URL 저장
        sessionStorage.setItem("lastUrl", currentUrl);
      }

      return false;
    };

    // F5 키 또는 Ctrl+R 감지
    const handleKeyDown = (event) => {
      if (
        (event.key === "r" && (event.metaKey || event.ctrlKey)) ||
        event.key === "F5"
      ) {
        // F5 키 코드
        event.preventDefault();

        // if (customerId !== "") {
        //   navigate("/EduboardManage");
        // } else {
          navigate("/EducationDashBoard");
        // }
      }
    };

    // 함수 실행
    detectRefresh();

    // 이벤트 리스너 등록
    window.addEventListener("keydown", handleKeyDown);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  const handleGoBack = async () => {
    try {
      // 현재 저장된 데이터를 가져온다
      let currentData;
      const currentViewId = customerId;

      // currentData = await getViewDetailOnServer(currentViewId, isLoggedIn);

      // console.log("currentData", currentData);

      if (
        currentData &&
        currentData.activateCode &&
        Array.isArray(currentData.activateCode)
      ) {
        // activateCode 배열에서 state와 activeState가 1인 항목들의 updateState를 1로 변경
        const updatedActivateCode = currentData.activateCode.map((item) => {
          if (item.state === 1 && item.activeState === 1) {
            return {
              ...item,
              updateState: 1,
            };
          }
          return item;
        });

        // 기존 데이터 유지하면서 activateCode만 업데이트
        const updateData = {
          ...currentData,
          activateCode: updatedActivateCode,
        };

        // 데이터 타입에 따라 적절한 업데이트 함수 호출
        await updateEduViewOnServer(currentViewId, updateData);

        // console.log("activateCode 업데이트 완료:", updatedActivateCode);
      }

      // 완료 후 페이지 이동
      navigate("/EducationDashBoard?view=contentsList");
    } catch (error) {
      console.error("돌아가기 처리 중 오류 발생:", error);
      // 오류가 발생해도 페이지는 이동
      navigate("/EducationDashBoard?view=contentsList");
    }
  };

  return (
    <>
      <DropzoneStyles />
      <ContentsWrap>
        {/* <OrganismIncNavigation /> */}
        {/* <MoleculeHeader /> */}
        <MoleculeCreateDisplayHeader
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          completedSteps={completedSteps}
          isLoading={isLoading}
          isLoadingReport={isLoadingReport}
          onPreview={handleTemplatePreview}
          onSubmitConcept={handleSubmitConcept}
          onSubmitReport={handleSubmitPurpose}
          onDisplayConversion={handleDisplayConversion}
          hasContentDraft={showTemplateSelection}
          onConfirmContent={handleConfirmContent}
          isLoadingTemplate={isLoadingTemplate}
          // 1단계에서 파일 업로드나 텍스트 입력이 있는지 확인
          canProceedFromStep1={
            activeTab === 1
              ? (interviewModeType === "conceptBoard" &&
                  fileNames &&
                  fileNames.length > 0) ||
                (interviewModeType === "explanation" &&
                  businessDescription &&
                  businessDescription.trim().length > 0)
              : // || (interviewModeType === "article" && selectedMessage)
                true
          }
          // 2단계에서 모든 필수 항목이 선택되었는지 확인
          canProceedFromStep2={
            activeTab === 2
              ? // selectedPurposes.customerList &&
                selectedTargetAudience
              : true
          }
          canProceedFromStep3={
            activeTab === 3 && showTemplateSelection
              ? selectedDesignConcepts.length > 0
              : activeTab === 3
              ? autoDisplayFileAnalysis?.title && 
                autoDisplayFileAnalysis.title.trim() !== ''
              : true
          }
        />

        <MainContent Wide1030>
          <DesignAnalysisWrap>
            {activeTab === 1 && (
              <TabContent5>
                <>
                  <div className="content">
                    <TabContent5Item required>
                      <div style={{ height: "20px" }}></div> {/* 간격용 div */}
                      <H3
                        color="gray800"
                        style={{ textAlign: "left", marginBottom: "12px" }}
                      >
                        AI 콘텐츠 생성을 위한 자료를 업로드해주세요{" "}
                      </H3>
                      {/* <InfoBox>
                        <InfoContent>
                          <Body2
                            color="black"
                            style={{
                              fontWeight: "600",
                              textAlign: "left",
                              fontSize: "20px",
                            }}
                          >
                            {selectedDevice?.deviceTitle}
                          </Body2>
                          <DeviceInfoBox>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceDPI}
                            </Body3>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceInch}
                            </Body3>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceWidthMM}x
                              {selectedDevice?.deviceSpec.deviceHeightMM} (mm)
                            </Body3>
                          </DeviceInfoBox>
                        </InfoContent>
                      </InfoBox> */}
                    </TabContent5Item>
                  </div>

                  <div className="content">
                    <TabContent5Item required>
                      <InterviewModeSelection style={{ marginBottom: "-5px" }}>
                        <Button
                          Medium
                          Outline
                          style={{
                            backgroundColor:
                              interviewModeType === "conceptBoard"
                                ? "#F7F8FA"
                                : "transparent",
                            borderColor:
                              interviewModeType === "conceptBoard"
                                ? "#E0E4EB"
                                : "#E0E4EB",
                          }}
                          onClick={() => {
                            if (toolSteps >= 1 || isLoadingPreset) return;
                            setInterviewModeType("conceptBoard");
                          }}
                          disabled={toolSteps >= 1 || isLoadingPreset}
                        >
                          <InputText color="gray700">파일 업로드</InputText>
                        </Button>

                        <Button
                          Medium
                          Outline
                          style={{
                            backgroundColor:
                              interviewModeType === "explanation"
                                ? "#F7F8FA"
                                : "transparent",
                            borderColor:
                              interviewModeType === "explanation"
                                ? "#E0E4EB"
                                : "#E0E4EB",
                          }}
                          onClick={() => {
                            if (toolSteps >= 1 || isLoadingPreset) return;
                            setInterviewModeType("explanation");
                            // 텍스트로 작성 모드로 전환할 때 업로드된 파일들 삭제
                            setUploadedFiles([]);
                            setFileNames([]);
                          }}
                          disabled={toolSteps >= 1 || isLoadingPreset}
                        >
                          <InputText color="gray700">텍스트로 작성</InputText>
                        </Button>
                        {/* <Button
                          Medium
                          Outline
                          style={{
                            backgroundColor:
                              interviewModeType === "article"
                                ? "#F7F8FA"
                                : "transparent",
                            borderColor:
                              interviewModeType === "article"
                                ? "#E0E4EB"
                                : "#E0E4EB",
                          }}
                          onClick={() => {
                            if (toolSteps >= 1 || isLoadingPreset) return;
                            setInterviewModeType("article");
                          }}
                          disabled={toolSteps >= 1 || isLoadingPreset}
                        >
                          <InputText color="gray700">게시글로 시작</InputText>
                        </Button> */}
                      </InterviewModeSelection>

                      {interviewModeType === "conceptBoard" && (
                        <div className="content" style={{ marginTop: "5px" }}>
                          <MoleculeFileUpload
                            fileNames={fileNames ?? []}
                            handleChangeStatus={handleChangeStatus}
                            toolSteps={toolSteps}
                          />
                        </div>
                      )}
                    </TabContent5Item>

                    {interviewModeType === "explanation" && (
                      <>
                        <FormBox Large style={{ marginTop: "-20px" }}>
                          <CustomTextarea
                            Edit
                            rows={6}
                            placeholder="텍스트를 입력해주세요."
                            value={businessDescription}
                            onChange={(e) =>
                              setBusinessDescription(e.target.value)
                            }
                            status="valid"
                            disabled={toolSteps >= 1}
                          />
                        </FormBox>
                      </>
                    )}
                    {/* {interviewModeType === "article" && (
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "820px",
                          margin: "0 auto",
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          marginTop: "20px",
                        }}
                      >
                        {messages.map((msg) => (
                          <MoleculeMessageCard
                            key={msg.id}
                            id={msg.id}
                            translatedText={msg.translate}
                            originalText={msg.original}
                            isSelected={msg.id === selectedMessage?.id}
                            onSelect={() => {
                              if (toolSteps >= 1) return;
                              setSelectedMessage(msg);
                            }}
                            disabled={toolSteps >= 1}
                          />
                        ))}
                      </div>
                    )} */}
                  </div>

                  {/* <Button
                        Other
                        Primary
                        Fill
                        Round
                        onClick={handleSubmitConcept}
                        
                      >
                        다음
                      </Button>
                   */}
                </>
              </TabContent5>
            )}

            {activeTab === 2 && completedSteps.includes(1) && (
              <TabContent5>
                {isLoading ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      minHeight: "200px",
                      alignItems: "center",
                    }}
                  >
                    <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    <div style={{ height: "520px" }}></div> {/* 간격용 div */}
                  </div>
                ) : (
                  <>
                    <div className="content">
                      <TabContent5Item required>
                        <div style={{ height: "20px" }}></div>{" "}
                        {/* 간격용 div */}
                        <H3
                          color="gray800"
                          style={{ textAlign: "left", marginBottom: "-12px" }}
                        >
                          콘텐츠 주요 내용 및 디스플레이 정보 ​{" "}
                        </H3>
                        <ContentAnalysisSection>
                          <MoleculeAnalysisCard
                            values={{
                              deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                              analysisData: autoDisplayFileAnalysis,
                            }}
                          />

                          <ContentOptionsSection>
                            <H3
                              color="gray800"
                              style={{ textAlign: "left", marginTop: "0px" }}
                            >
                              콘텐츠를 전달할 주 대상자를 지정해 주세요{" "}
                            </H3>

                            <TabContent5Item>
                              {/* <div className="title">
                                <Body3 color="gray700">콘텐츠 목적</Body3>
                              </div> */}

                              {/* <SelectBox ref={customerListRef}>
                                <SelectBoxTitle
                                  onClick={() => {
                                    if (completedSteps.includes(2)) return;
                                    handleSelectBoxClick(
                                      "customerList",
                                      customerListRef
                                    );
                                  }}
                                >
                                  <Body2
                                    color={
                                      selectedPurposes.customerList
                                        ? "gray800"
                                        : "gray300"
                                    }
                                  >
                                    {selectedPurposes.customerList ||
                                      "선택해주세요"}
                                  </Body2>
                                  <images.ChevronDown
                                    width="24px"
                                    height="24px"
                                    color={palette.gray500}
                                    style={{
                                      transform: selectBoxStates.customerList
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                      transition: "transform 0.3s ease",
                                    }}
                                  />
                                </SelectBoxTitle>

                                {selectBoxStates.customerList && (
                                  <SelectBoxList
                                    dropUp={dropUpStates.customerList}
                                    style={{ zIndex: "1000" }}
                                  >
                                    {contentTypeOptions.map((option) => (
                                      <SelectBoxItem
                                        key={option}
                                        onClick={() => {
                                          if (completedSteps.includes(2))
                                            return;
                                          handleContentTypeSelect(option);
                                        }}
                                      >
                                        <Body2 color="gray700" align="left">
                                          {option}
                                        </Body2>
                                      </SelectBoxItem>
                                    ))}
                                  </SelectBoxList>
                                )}
                              </SelectBox> */}

                              {/* <div
                                className="title"
                                style={{ marginTop: "24px" }}
                              >
                                <Body3 color="gray700">콘텐츠 대상자</Body3>
                              </div> */}
                              <TargetAudienceRadioContainer>
                                <TargetAudienceSection>
                                  <SectionTitle>학생</SectionTitle>
                                  <RadioButtonRow>
                                    {targetAudienceOptions
                                      .slice(0, 4)
                                      .map((option) => (
                                        <RadioButtonItem
                                          key={option.id}
                                          selected={
                                            selectedTargetAudience.includes(option.id)
                                          }
                                          onClick={() =>
                                            handleTargetAudienceSelect(option.id)
                                          }
                                        >
                                          <RadioButton
                                            checked={selectedTargetAudience.includes(
                                              option.id
                                            )}
                                            disabled={completedSteps.includes(2)}
                                          />
                                          <RadioButtonLabel>
                                            <RadioButtonContent>
                                              <RadioButtonText
                                                selected={
                                                  selectedTargetAudience.includes(
                                                    option.id
                                                  )
                                                }
                                              >
                                                {option.name}
                                              </RadioButtonText>
                                              <RadioButtonIcon
                                                selected={
                                                  selectedTargetAudience.includes(
                                                    option.id
                                                  )
                                                }
                                              >
                                                {option.icon}
                                              </RadioButtonIcon>
                                            </RadioButtonContent>
                                          </RadioButtonLabel>
                                        </RadioButtonItem>
                                      ))}
                                  </RadioButtonRow>
                                </TargetAudienceSection>

                                {/* <TargetAudienceSection>
                                  <SectionTitle>비학생 대상자</SectionTitle>
                                  <RadioButtonRow>
                                    {targetAudienceOptions
                                      .slice(4)
                                      .map((option) => (
                                        <RadioButtonItem
                                          key={option.id}
                                          selected={
                                            selectedTargetAudience.includes(option.id)
                                          }
                                          onClick={() =>
                                            handleTargetAudienceSelect(option.id)
                                          }
                                        >
                                          <CheckCircle
                                            checked={selectedTargetAudience.includes(
                                              option.id
                                            )}
                                            disabled={completedSteps.includes(2)}
                                          />
                                          <RadioButtonLabel>
                                            <RadioButtonContent>
                                              <RadioButtonText
                                                selected={
                                                  selectedTargetAudience.includes(
                                                    option.id
                                                  )
                                                }
                                              >
                                                {option.name}
                                              </RadioButtonText>
                                              <RadioButtonIcon
                                                selected={
                                                  selectedTargetAudience.includes(
                                                    option.id
                                                  )
                                                }
                                              >
                                                {option.icon}
                                              </RadioButtonIcon>
                                            </RadioButtonContent>
                                          </RadioButtonLabel>
                                        </RadioButtonItem>
                                      ))}
                                  </RadioButtonRow>
                                </TargetAudienceSection> */}
                              </TargetAudienceRadioContainer>
                            </TabContent5Item>
                          </ContentOptionsSection>
                        </ContentAnalysisSection>
                      </TabContent5Item>
                    </div>

                    {/* <Button
                        Other
                        Primary
                        Fill
                        Round
                        onClick={() => {
                          handleSubmitPurpose();
                        }}
                    
                      >
                        다음
                      </Button>
                */}
                  </>
                )}
              </TabContent5>
            )}

            {activeTab === 3 &&
              (completedSteps.includes(2) || completedSteps.includes(3)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader
                        message={
                          "AI가 핵심 내용을 추출하여 디스플레이에 적합한 정보로 바꾸고 있어요"
                        }
                      />
                      <div style={{ height: "520px" }}></div> {/* 간격용 div */}
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          <div style={{ height: "20px" }}></div>{" "}
                          {/* 간격용 div */}
                          <H3
                            color="gray800"
                            style={{ textAlign: "left", marginBottom: "-12px" }}
                          >
                            콘텐츠 주요 내용 및 디스플레이 정보{" "}
                          </H3>
                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="template"
                              onButtonClick={() => {
                                setShowPreviewPopup(true);
                                // setSelectedTemplate(template);
                              }}
                              values={{
                                deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                                analysisData: autoDisplayFileAnalysis,
                                contentPurpose: selectedPurposes.customerList,
                                designConcept: selectedDesignConcepts,
                              }}
                            />

                            {isLoadingTemplate ? (
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                  minHeight: "200px",
                                  alignItems: "center",
                                }}
                              >
                                {/* <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" /> */}
                                <AtomPersonaLoader
                                  message={
                                    <>
                                      <span>디자인을 생성 중입니다</span>
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "400",
                                          color: palette.gray500,
                                        }}
                                      >
                                        {/* {" "}
                                        평균 소요 시간은 컨셉당 약 1분입니다.
                                        준비되면 바로 확인하실 수 있어요{" "} */}
                                      </span>
                                    </>
                                  }
                                />
                              </div>
                            ) : showTemplateSelection ? (
                              <ContentOptionsSection>
                                <H3
                                  color="gray800"
                                  style={{ textAlign: "left" }}
                                >
                                  아래에서 디자인 테마를 선택해주세요{" "}
                                </H3>
                                <TabContent5Item>
                                  <div
                                    className="title"
                                    style={{
                                      marginBottom: "16px",
                                      marginTop: "-8px",
                                    }}
                                  >
                                    {/* <Body3 color="gray700">배경 선택</Body3> */}
                                  </div>

                                  <OrganismDesignConceptSelector
                                    concepts={designConceptsData}
                                    selectedConcepts={selectedDesignConcepts}
                                    onSelect={handleDesignConceptSelect}
                                    disabled={completedSteps.includes(4)}
                                    titleData={
                                      autoDisplayContentGeneratorTitle[0]
                                    }
                                    markdownData={
                                      autoDisplayContentGeneratorMarkdown
                                    }
                                    onPreview={(concept) => {
                                      // 미리보기 기능 구현 - 필요시 추가
                                      console.log("Preview concept:", concept);
                                    }}
                                  />

                                  {/* <H3
                                    color="gray800"
                                    style={{
                                      textAlign: "left",
                                      marginTop: "30px",
                                    }}
                                  >
                                    콘텐츠 시안 (
                                    {
                                      templateData.filter((template) =>
                                        selectedDesignConcepts.includes(
                                          template.category
                                        )
                                      ).length
                                    }
                                    개)
                                  </H3>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "20px",
                                      marginTop: "24px",
                                      width: "100%",
                                    }}
                                  >
                                    {templateData
                                      .filter((template) =>
                                        selectedDesignConcepts.includes(
                                          template.category
                                        )
                                      )
                                      .map((template) => (
                                        <MoleculeTemplateCard
                                          key={template.id}
                                          template={template}
                                          onPreview={() =>
                                            handleTemplatePreview(template)
                                          }
                                          isSelected={
                                            selectedTemplate === template.id
                                          }
                                          title={autoDisplayFileAnalysis?.title}
                                          // location={
                                          //   selectedDevice?.deviceLocation
                                          // }
                                          onSelect={handleTemplateSelect}
                                          selectedDesignConcepts={
                                            selectedDesignConcepts
                                          }
                                        />
                                      ))}
                                  </div> */}
                                </TabContent5Item>
                              </ContentOptionsSection>
                            ) : (
                              <ContentOptionsSection>
                                <TabContent5Item>
                                  {/* <div className="title">
                                    <Body1 color="gray700">콘텐츠 목적</Body1>
                                  </div>

                                  <SelectBox
                                    onClick={() => {
                                      if (toolSteps >= 1) return;
                                      setIsSelectBoxOpen(!isSelectBoxOpen);
                                    }}
                                    disabled={toolSteps >= 1}
                                    style={{
                                      cursor:
                                        toolSteps >= 1
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <SelectBoxTitle>
                                      <Body2
                                        color={
                                          selectedPurposes.customerList
                                            ? "gray800"
                                            : "gray300"
                                        }
                                      >
                                        {selectedPurposes.customerList ||
                                          "선택해주세요"}
                                      </Body2>
                                      <images.ChevronDown
                                        width="24px"
                                        height="24px"
                                        color={palette.gray500}
                                        style={{
                                          transform:
                                            selectBoxStates.customerList
                                              ? "rotate(180deg)"
                                              : "rotate(0deg)",
                                          transition: "transform 0.3s ease",
                                        }}
                                      />
                                    </SelectBoxTitle>

                                    {selectBoxStates.customerList && (
                                      <SelectBoxList
                                        dropUp={dropUpStates.customerList}
                                        style={{ zIndex: "1000" }}
                                      >
                                        {contentTypeOptions.map((option) => (
                                          <SelectBoxItem
                                            key={option}
                                            onClick={() =>
                                              handleContentTypeSelect(option)
                                            }
                                          >
                                            <Body2 color="gray700" align="left">
                                              {option}
                                            </Body2>
                                          </SelectBoxItem>
                                        ))}
                                      </SelectBoxList>
                                    )}
                                  </SelectBox> */}

                                  {/* <div
                                    className="title"
                                    style={{ marginTop: "24px" }}
                                  >
                                    <Body1 color="gray700">
                                      콘텐츠 방향성{" "}
                                    </Body1>
                                  </div> */}
                                  {/* <FormBox Large style={{ textAlign: "left" }}>
                                    <CustomTextarea
                                      Edit
                                      rows={1}
                                      placeholder="작성해주세요"
                                      value={contentTarget}
                                      onChange={(e) =>
                                        setContentTarget(e.target.value)
                                      }
                                      status="valid"
                                    />
                                    {
                                      autoDisplayContentGenerator?.content_direction
                                    }
                                  </FormBox> */}
                                  <ContentInputSection>
                                    <H3
                                      color="gray800"
                                      style={{ textAlign: "left" }}
                                    >
                                      콘텐츠 내용과 대상이 잘 맞는지
                                      확인해주세요.​{" "}
                                    </H3>
                                    <InputGroup>
                                      <Label>콘텐츠 제목</Label>
                                      <FormBox Large>
                                        <CustomTextarea
                                          Edit
                                          rows={1}
                                          placeholder="콘텐츠 리스트에서 쉽게 알아볼 수 있도록 작성해주세요"
                                          value={
                                            autoDisplayFileAnalysis?.title || ""
                                          }
                                          onChange={(e) => {
                                            setAutoDisplayFileAnalysis(
                                              (prev) => ({
                                                ...prev,
                                                title: e.target.value,
                                              })
                                            );
                                          }}
                                          status="valid"
                                          maxLength={50}
                                        />
                                      </FormBox>
                                    </InputGroup>

                                    <InputGroup>
                                      <Label>콘텐츠 전달 대상자</Label>
                                      <FormBox Large>
                                        <CustomTextarea
                                          Edit
                                          rows={1}
                                          placeholder="콘텐츠의 방향성과 목적을 작성해주세요"
                                          value={contentTarget}
                                          // onChange={(e) =>
                                          //   setContentTarget(e.target.value)
                                          // }
                                          status="valid"
                                        />
                                      </FormBox>
                                    </InputGroup>
                                  </ContentInputSection>

                                  <div
                                    className="title"
                                    style={{ marginTop: "0px" }}
                                  >
                                    <Body1 color="gray700">
                                      디스플레이 콘텐츠 내용{" "}
                                    </Body1>
                                  </div>

                                  {/* 선택된 디자인 컨셉별로 콘텐츠 박스 생성 */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "16px",
                                    }}
                                  >
                                    <ContentConceptBox>
                                      <ContentConceptHeader>
                                        <ConceptTitle></ConceptTitle>
                                        <RegenerateButton
                                          onClick={() =>
                                            handleSubmitPurpose(true)
                                          }
                                          // disabled={regeneratingConcepts.has(
                                          //   concept
                                          // )}
                                        >
                                          <svg
                                            width="13"
                                            height="13"
                                            viewBox="0 0 13 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M6.93569 1.10238C6.73825 3.72605 4.44413 4.92239 3.01117 5.27398C2.81081 5.32314 2.66211 5.49758 2.66211 5.70389C2.66211 5.93696 2.85208 6.12328 3.08346 6.15135C5.21146 6.40957 6.69369 8.57558 6.91937 9.99338C6.95039 10.1882 7.10929 10.3482 7.30661 10.3482C7.50393 10.3482 7.66218 10.1869 7.67846 9.99024C7.88338 7.51524 10.2016 6.46546 11.655 6.18303C11.8603 6.14314 12.0161 5.96846 12.0161 5.75933C12.0161 5.53126 11.8294 5.34842 11.6022 5.32934C8.87385 5.10025 7.89142 2.61312 7.69599 1.07933C7.67136 0.886049 7.51151 0.734375 7.31667 0.734375C7.1138 0.734375 6.95091 0.900081 6.93569 1.10238Z"
                                              fill="#226FFF"
                                            />
                                            <path
                                              d="M1.88689 8.77442C1.80044 9.92325 0.795916 10.4471 0.168467 10.601C0.0807353 10.6226 0.015625 10.6989 0.015625 10.7893C0.015625 10.8913 0.098793 10.9729 0.200148 10.9849C1.13514 11.0952 1.78541 12.0247 1.88075 12.6673C1.89343 12.7528 1.96291 12.8229 2.04931 12.8229C2.13571 12.8229 2.205 12.7522 2.21213 12.6661C2.30186 11.5824 3.31694 11.1227 3.95333 10.9991C4.04322 10.9816 4.11144 10.9051 4.11144 10.8136C4.11144 10.7137 4.02971 10.6336 3.9302 10.6253C2.73555 10.525 2.30538 9.43593 2.21981 8.76433C2.20902 8.67969 2.13903 8.61328 2.05371 8.61328C1.96488 8.61328 1.89356 8.68584 1.88689 8.77442Z"
                                              fill="#226FFF"
                                            />
                                          </svg>
                                          <span>다시 생성</span>
                                        </RegenerateButton>
                                      </ContentConceptHeader>
                                      <ContentConceptBody>
                                        {/* {regeneratingConcepts.has(
                                              concept
                                            ) ? (
                                              <div
                                                style={{
                                                  width: "100%",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  minHeight: "200px",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <AtomPersonaLoader
                                                  message={`${concept} 콘텐츠를 재생성하고 있습니다`}
                                                />
                                              </div>
                                            ) : ( */}
                                        <div
                                          className="markdown-body core-value-section"
                                          style={{
                                            color: palette.gray800,
                                            textAlign: "left",
                                            "& h1, & h2, & h3, & h4, & h5, & h6":
                                              {
                                                marginBottom: "0px",
                                                marginTop: "0px",
                                              },
                                            "& h1 + p, & h2 + p, & h3 + p, & h4 + p, & h5 + p, & h6 + p":
                                              {
                                                marginTop: "12px",
                                              },
                                          }}
                                        >
                                          <h1
                                            style={{
                                              fontSize: "40px",
                                              fontWeight: "700",
                                              marginBottom: "20px",
                                            }}
                                          >
                                            {autoDisplayContentGeneratorTitle.length >
                                              0 &&
                                              autoDisplayContentGeneratorTitle[0][0] + " " + autoDisplayContentGeneratorTitle[0][1]
                                              }
                                          </h1>
                                          <Markdown>
                                            {
                                              autoDisplayContentGeneratorMarkdown[0]
                                            }
                                          </Markdown>
                                          <Markdown>
                                            {
                                              autoDisplayContentGeneratorMarkdown[1]
                                            }
                                          </Markdown>
                                        </div>
                                        {/* )} */}
                                      </ContentConceptBody>
                                    </ContentConceptBox>
                                  </div>
                                </TabContent5Item>
                              </ContentOptionsSection>
                            )}
                          </ContentAnalysisSection>
                        </TabContent5Item>
                      </div>

                      {/* <ButtonContainer style={{ marginTop: "0px" }}>
                        {!showTemplateSelection && !isLoadingTemplate && (
                          <Button
                            Primary
                            Edit
                            Large
                            onClick={() => {
                              handleSubmitPurpose();
                            }}
                          >
                            내용 재생성
                          </Button>
                        )}
                                              
                      <Button
                        Primary
                        Large
                        Fill
                        onClick={handleDisplayConversion}
                      >
                        디스플레이로 변환
                      </Button>
                      </ButtonContainer> */}
                    </>
                  )}
                </TabContent5>
              )}

            {activeTab === 4 &&
              (completedSteps.includes(3) || completedSteps.includes(4)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          <H3
                            color="gray800"
                            style={{ textAlign: "left", marginBottom: "-20px" }}
                          >
                            확정된 콘텐츠를 화면에 적용해보세요{" "}
                          </H3>
                          <DashedLine />
                          <CompletionContainer>
                            <CompletionIcon>
                              <CheckIcon>
                                <svg
                                  width="28"
                                  height="26"
                                  viewBox="0 0 28 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M26.7408 1.07458C27.9568 1.9055 28.269 3.56483 27.438 4.78081L13.7714 24.7808C13.3237 25.4359 12.6076 25.8576 11.8176 25.9314C11.0277 26.0052 10.2458 25.7234 9.68463 25.1625L1.34609 16.8292C0.304367 15.7881 0.30384 14.0997 1.34491 13.0579C2.38599 12.0162 4.07443 12.0157 5.11615 13.0568L11.1813 19.1181L23.0346 1.77179C23.8655 0.555813 25.5249 0.243661 26.7408 1.07458Z"
                                    fill="white"
                                  />
                                </svg>
                              </CheckIcon>
                            </CompletionIcon>

                            <CompletionMessage>
                              <H3
                                color="gray800"
                                style={{
                                  marginBottom: "8px",
                                  marginTop: "16px",
                                }}
                              >
                                콘텐츠 등록이 완료되었습니다
                              </H3>
                            </CompletionMessage>
                          </CompletionContainer>

                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="template"
                              onButtonClick={() => {
                                setShowPreviewPopup(true);
                                // setSelectedTemplate(template);
                              }}
                              values={{
                                deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                                analysisData: autoDisplayFileAnalysis,
                                contentPurpose: selectedPurposes.customerList,
                                // designConcept: (
                                //   templateData.find(template =>s
                                //     selectedDesignConcepts.includes(template.category)
                                //   )?.category || "기본 심플형"
                                // ),
                                designConcept:
                                  selectedDesignConcepts || "concept1",
                              }}
                            />
                          </ContentAnalysisSection>
                          <DashedLine />
                        </TabContent5Item>
                      </div>

                      <ButtonContainer>
                        {/* <Button
                          Primary
                          Edit
                          Large
                          onClick={() => {
                            navigate("/DashBoard");
                          }}
                        >
                          나중에 사용하기
                        </Button> */}
                        <Button
                          Primary
                          Large
                          Fill
                          style={{
                            width: "120px",
                            height: "40px",
                            fontSize: "16px",
                          }}
                          onClick={handleGoBack}
                        >
                          돌아가기
                        </Button>
                        {/* <Button Primary Large Fill onClick={handleDisplayView}>
                          콘텐츠 활성화 하기
                        </Button> */}
                      </ButtonContainer>
                    </>
                  )}
                </TabContent5>
              )}
          </DesignAnalysisWrap>
        </MainContent>
      </ContentsWrap>

      {showTemplatePreview && (
        <OrganismDisplayViewEduPreview
          template={templateToPreview}
          onClose={handleCloseTemplatePreview}
          title={autoDisplayFileAnalysis?.title}
          displayWidth={selectedDevice?.deviceSpec?.deviceWidth || "1080"}
          displayHeight={selectedDevice?.deviceSpec?.deviceHeight || "1920"}
          jsonData={autoDisplayContentGeneratorJson}
          contentsPurpose={contentsPurpose}
          contentsDesignConcept={selectedDesignConcepts}
          markdownData={
            autoDisplayContentGeneratorMarkdown[
              selectedDesignConcepts.findIndex(
                (c) => c === templateToPreview.category
              )
            ]
          }
          titleData={
            autoDisplayContentGeneratorTitle[
              selectedDesignConcepts.findIndex(
                (c) => c === templateToPreview.category
              )
            ]
          }
        />
      )}

      {showPopupError && (
        <PopupWrap
          Warning
          title="다시 입력해 주세요."
          message="현재 입력하신 정보는 목적을 생성할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => window.location.reload()}
        />
      )}

      {showPopupFileSize && (
        <PopupWrap
          Warning
          title="파일 크기 초과"
          message="파일 크기는 20MB를 초과할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => setShowPopupFileSize(false)}
        />
      )}

      {showPopupSave && (
        <PopupWrap
          Check
          title="리포트가 저장되었습니다."
          message="저장된 리포트는 '보관함'을 확인해주세요"
          buttonType="Outline"
          closeText="보관함 바로가기"
          confirmText="리포트 계속 확인"
          isModal={false}
          onCancel={() => setShowPopupSave(false)}
          onConfirm={() => setShowPopupSave(false)}
        />
      )}

      {showCreatePersonaPopup && (
        <PopupWrap
          Check
          title="NPS 분석을 시작합니다"
          message="페르소나 기반 NPS 분석을 진행하시겠습니까?"
          buttonType="Outline"
          closeText="취소"
          confirmText="시작하기"
          isModal={false}
          onCancel={() => {
            setShowCreatePersonaPopup(false);
            navigate("/Tool");
          }}
          onConfirm={handleConfirmCredit}
        />
      )}

      {showCreditPopup && (
        <PopupWrap
          Warning
          title="서비스 이용 안내"
          message="해당 서비스를 이용하시겠습니까?"
          buttonType="Outline"
          closeText="확인"
          isModal={false}
          onCancel={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
          onConfirm={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
        />
      )}

      {showPreviewPopup && (
        <>
          <StyledInterviewPopup>
            <div
              style={{
                maxWidth: "700px",
                width: "100%",
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: "20px",
                padding: "32px 32px",
                borderRadius: "15px",
                background: "#FFFFFF",
                boxShadow: "4px 4px 30px rgba(0, 0, 0, 0.15)",
              }}
            >
              <div className="header">
                <H4
                  style={{
                    fontSize: "16px",
                    marginBottom: "16px",
                  }}
                >
                  디스플레이 콘텐츠 자세히 보기
                  <span
                    className="close"
                    onClick={() => setShowPreviewPopup(false)}
                  />
                </H4>
                {/* <div
                  style={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#E0E4EB",
                    marginBottom: "16px",
                  }}
                /> */}
              </div>

              <div className="content" style={{ textAlign: "left" }}>
                <div style={{ marginBottom: "12px" }}>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 목적
                  </Body2>
                  <DetailBox>
                    <Body2
                      color="gray800"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {selectedPurposes.customerList}
                    </Body2>
                  </DetailBox>
                </div>

                {/* <div style={{ marginBottom: "12px" }}>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 방향성
                  </Body2>
                  <DetailContentBox>
                    <Body3 color="gray600">{contentTarget}</Body3>
                  </DetailContentBox>
                </div> */}

                <div>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 내용
                  </Body2>
                  <DetailContentBox>
                    <Body3
                      color="gray600"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {autoDisplayFileAnalysis?.detail}
                    </Body3>
                  </DetailContentBox>
                </div>
              </div>
            </div>
          </StyledInterviewPopup>
        </>
      )}
    </>
  );
};

export default PageCreateEducationContent;

const DesignAnalysisWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  margin-top: 60px;
`;

const InterviewModeSelection = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 48px;

  button {
    flex: 0 0 auto;
    max-width: 200px;
  }

  .button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;
  }
`;

export const CheckCircle = styled.input`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;

  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23226FFF'/%3E%3Cpath d='M6.76562 12.4155L9.9908 15.6365L17.2338 8.36426' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' stroke='%23E0E4EB'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  + label {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;

    + label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

const StyledInterviewPopup = styled(InterviewPopup)`
  .markdown-body {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: ${palette.gray800};
      font-weight: 600;
    }
    p,
    li,
    span {
      line-height: 1.55;
    }
    p {
      margin-bottom: 8px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 18px;
    }
  }
  .core-value-section h2:nth-of-type(4) ~ p:last-of-type {
    margin-bottom: 12px !important;
  }

  h2:nth-of-type(4) ~ h2:nth-of-type(5) {
    margin-top: 20px;
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  // background: ${palette.gray100};
  width: 100%;
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DeviceInfoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  // padding: 12px 16px;
  border-radius: 6px;
  // margin-top: 8px;

  > * {
    white-space: nowrap;
  }

  > *:not(:last-child)::after {
    content: "|";
    margin-left: 8px;
    color: #e0e4eb;
  }
  // > *:not(:last-child):not(:nth-last-child(2))::after {
  //   content: "|";
  //   margin-left: 8px;
  //   color: #e0e4eb;
  // }
`;

const ContentAnalysisSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 24px 0 0px 0;
  width: 100%;
`;

const ContentOptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FestivalInfoBox = styled.div`
  border: 1px solid ${palette.outlineGray};
  border-radius: 16px;
  padding: 24px;
  margin-top: 16px;
  min-width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const CompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 32px auto;
  text-align: center;
  width: 100%;
`;

const CompletionIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${palette.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const CompletionMessage = styled.div`
  text-align: center;
  max-width: 400px;
`;

const DashedLine = styled.div`
  width: 100%;
  height: 1px;
  border-top: 2px solid ${palette.gray300};
  margin: 0px;
  margin-top: 32px;
  margin-bottom: 36px;
`;

const DetailBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;

const DetailContentBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;

const ContentConceptBox = styled.div`
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  min-width: 820px;
  overflow: hidden;
`;

const ContentConceptHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 8px 20px;
  background: #f2f6ff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: none;
`;

const ConceptTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #090f15;
  line-height: 24px;
  font-family: Pretendard;
`;

const RegenerateButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  background: transparent;
  color: #226fff;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 400;
  font-family: Pretendard;
  line-height: 22.5px;

  span {
    color: #226fff;
  }

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ContentConceptBody = styled.div`
  padding: 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  .markdown-body {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: #090f15;
      font-weight: 400;
      font-family: Pretendard;
    }
    p,
    li,
    span {
      line-height: 1.55;
      color: #090f15;
      font-size: 19px;
      font-weight: 400;
      font-family: Pretendard;
      line-height: 28.5px;
    }
    p {
      margin-bottom: 8px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 18px;
    }
  }
  .core-value-section h2:nth-of-type(4) ~ p:last-of-type {
    margin-bottom: 12px !important;
  }

  h2:nth-of-type(4) ~ h2:nth-of-type(5) {
    margin-top: 20px;
  }
`;

const TargetAudienceRadioContainer = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  display: flex;
`;

const TargetAudienceSection = styled.div`
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  display: flex;
`;

const SectionTitle = styled.span`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.55;
  word-wrap: break-word;
  text-align: inherit;
`;

const RadioButtonRow = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  gap: 13px;
  display: flex;
  flex-wrap: wrap;
`;

const RadioButtonItem = styled.div`
  width: 195.25px;
  padding: 12px;
  background: ${(props) =>
    props.selected ? "rgba(34, 111, 255, 0.04)" : "white"};
  border-radius: 10px;
  border: 1px solid ${(props) => (props.selected ? "#226FFF" : "#E0E4EB")};
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: flex;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) =>
      props.selected ? "rgba(34, 111, 255, 0.04)" : "#F7F8FA"};
    border-color: ${(props) => (props.selected ? "#226FFF" : "#BCC4D0")};
  }
`;

const RadioButtonLabel = styled.label`
  cursor: pointer;
  flex: 1;
`;

const RadioButtonContent = styled.div`
  justify-content: center;
  align-items: center;
  gap: 12px;
  display: flex;
`;

const RadioButtonText = styled.span`
  color: ${(props) => (props.selected ? "#226FFF" : "#666666")};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 24.8px;
  word-wrap: break-word;
`;

const RadioButtonIcon = styled.div`
  width: 44px;
  height: 44px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 36px;
    height: 36px;

    path {
      stroke: ${(props) => (props.selected ? "#226FFF" : "#DEDEDE")};
    }
    rect {
      stroke: ${(props) => (props.selected ? "#226FFF" : "#DEDEDE")};
    }
  }
`;
const Label = styled.label`
  color: #666666;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.55;
  text-align: left;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

const ContentInputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 0px;
  margin-bottom: 24px;
  width: 100%;
`;